/* Entropica Producer Atlas: store explorer.
   One stage (Globe or Web) and one sheet. Phones: the sheet slides over the stage.
   Wide screens: the sheet docks left. Data is the public allowlist only
   (pipeline/export_public.py); nothing here calls an API or writes anywhere but localStorage. */
(() => {
'use strict';
const root = document.querySelector('[data-eat]');
if (!root || root.dataset.eatReady) return;
root.dataset.eatReady = '1';

/* ---------- helpers ---------- */
const $ = (s, scope = root) => scope.querySelector(s);
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const fold = s => String(s || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase();
const arr = v => (Array.isArray(v) ? v : []);
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const plural = (n, one, many) => `${n.toLocaleString('en-US')} ${n === 1 ? one : (many || one + 's')}`;
const byName = (a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' });
const D2R = Math.PI / 180;
const wide = matchMedia('(min-width: 900px)');
const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const day = iso => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? `${+m[3]} ${MONTHS[+m[2] - 1]} ${m[1]}` : ''; };
const local = {
  get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch { return d; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch { return false; } },
};
// The brand curve, cubic-bezier(0.22, 1, 0.36, 1), for motion driven from script.
const EASE = (() => {
  const bez = (t, a, b) => 3 * a * t * (1 - t) ** 2 + 3 * b * t * t * (1 - t) + t ** 3;
  return x => {
    if (x <= 0) return 0;
    if (x >= 1) return 1;
    let lo = 0, hi = 1, t = x;
    for (let i = 0; i < 24; i++) { t = (lo + hi) / 2; if (bez(t, 0.22, 0.36) < x) lo = t; else hi = t; }
    return bez(t, 1, 1);
  };
})();
const hash = s => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return ((h >>> 0) % 2000) / 1000 - 1; };
const ICON = {
  back: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>',
  caret: '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  save: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2.5h8v11L8 10.6 4 13.5z" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  saved: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2.5h8v11L8 10.6 4 13.5z" fill="currentColor" stroke="currentColor" stroke-width="1.1"/></svg>',
  share: '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 10V2.5M5 5.2 8 2.3l3 2.9M3.5 8.5v5h9v-5" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  out: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2.5h5.5V8M9.5 2.5 2.5 9.5" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  chev: '<svg viewBox="0 0 8 12" aria-hidden="true"><path d="M2 1.5 6.5 6 2 10.5" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
};

/* ---------- elements (rendered by the Liquid section) ---------- */
const el = {
  stage: $('.eat-stage'), map: $('.eat-map'), web: $('.eat-web'), caption: $('.eat-caption'), tip: $('.eat-tip'),
  sheet: $('.eat-sheet'), head: $('.eat-head'), body: $('.eat-body'), search: $('.eat-searchbar'),
  q: $('.eat-q'), qClear: $('.eat-q-clear'), chips: $('.eat-chips'), nav: $('.eat-nav'),
  navTitle: $('.eat-nav-title'), navActions: $('.eat-nav-actions'),
  picker: $('.eat-picker'), scrim: $('.eat-scrim'), toast: $('.eat-toast'), status: $('.eat-announce'),
};

/* ---------- sit under the store header ---------- */
function headerBottom() {
  let bottom = 0;
  for (const h of document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper')) {
    if (root.contains(h)) continue;
    const r = h.getBoundingClientRect();
    if (r.height > 0 && r.top < 60) bottom = Math.max(bottom, r.bottom);
  }
  return Math.round(bottom);
}
function placeUnderHeader() {
  const b = headerBottom();
  const vv = window.visualViewport;
  root.style.setProperty('--eat-bottom', Math.max(0, innerHeight - (vv ? vv.height + vv.offsetTop : innerHeight)) + 'px');
  if (b !== placeUnderHeader.last) { placeUnderHeader.last = b; root.style.setProperty('--eat-top', b + 'px'); }
}
placeUnderHeader();
addEventListener('load', placeUnderHeader);
if ('ResizeObserver' in window) {
  const h = document.querySelector('.shopify-section-group-header-group, sticky-header');
  if (h) new ResizeObserver(placeUnderHeader).observe(h);
}

/* ---------- saved producers and taste history (this browser only) ---------- */
const SAVED_KEY = 'entropica-explore-saved-v1', TASTE_KEY = 'entropica-explore-taste-v1';
const saved = new Set(arr(local.get(SAVED_KEY, [])).filter(k => typeof k === 'string'));
let ratings = local.get(TASTE_KEY, {});
if (!ratings || typeof ratings !== 'object' || Array.isArray(ratings)) ratings = {};
// Returns false when the browser refuses storage, so callers never claim a save that did not happen.
function persist() {
  return local.set(SAVED_KEY, [...saved]) && local.set(TASTE_KEY, ratings);
}
const NOT_KEPT = 'This browser is not keeping saved items. They last for this visit.';

/* ---------- data ---------- */
let A, P, LOTS, ROASTERS, COUNTRIES, lotsBy;
const PROCESSES = ['Washed', 'Natural', 'Honey', 'Anaerobic & experimental', 'Decaf'];
function processBucket(s) {
  s = fold(s);
  if (!s) return '';
  if (/decaf/.test(s)) return 'Decaf';
  if (/anaerob|inocul|culture|thermal|co-?ferm|yeast|nitrogen|carbonic|\basd\b|\+|sugarcane|koji/.test(s)) return 'Anaerobic & experimental';
  if (/honey/.test(s)) return 'Honey';
  if (/natural|dry/.test(s)) return 'Natural';
  if (/wash/.test(s)) return 'Washed';
  return '';
}
function lotName(l) {
  let n = String(l.name || 'Coffee').trim();
  const pre = (l.roaster || '') + ' - ';
  if (pre.length > 3 && n.toLowerCase().startsWith(pre.toLowerCase())) n = n.slice(pre.length);
  return n.trim() || 'Coffee';
}
function urlOf(v) { try { const u = new URL(v); return /^https?:$/.test(u.protocol) ? u : null; } catch { return null; } }
const SHOP_HOSTS = new Set(['entropicacoffee.com', 'www.entropicacoffee.com', location.hostname]);
function shopPath(l) {
  const u = urlOf(l.url) || urlOf(l.source_url);
  return u && SHOP_HOSTS.has(u.hostname) && u.pathname.startsWith('/products/') ? u.pathname : '';
}
function roasterUrl(l) {
  for (const v of [l.live_url, l.url, l.source_url]) { const u = urlOf(v); if (u && !SHOP_HOSTS.has(u.hostname)) return u.href; }
  return '';
}
function prepare(data) {
  A = data;
  A.roasters = A.roasters && typeof A.roasters === 'object' ? A.roasters : {};
  P = new Map();
  for (const p of arr(A.producers)) if (p && typeof p.key === 'string') P.set(p.key, p);
  ROASTERS = Object.keys(A.roasters).filter(r => arr(A.lots).some(l => l && l.roaster === r)).sort(byName);
  const rset = new Set(ROASTERS);
  LOTS = arr(A.lots).filter(l => l && l.id && rset.has(l.roaster)).map(l => {
    const keys = arr(l.producers).filter(k => P.has(k));
    if (!keys.length && P.has(l.producer)) keys.push(l.producer);
    const prod = P.get(keys[0]);
    const varieties = arr(l.varietal_c).length ? arr(l.varietal_c) : arr(l.varietals);
    const lot = { ...l, keys, display: lotName(l), country: l.country || arr(l.countries)[0] || prod?.country || '',
      bucket: processBucket(l.process_c || l.process), shop: shopPath(l), source: roasterUrl(l), varieties, notes: arr(l.notes) };
    lot._search = fold([lot.display, lot.roaster, lot.farm, lot.region, lot.country, lot.process, ...varieties, ...lot.notes, ...keys.map(k => P.get(k).name)].join(' '));
    return lot;
  });
  lotsBy = new Map();
  for (const l of LOTS) for (const k of l.keys) { if (!lotsBy.has(k)) lotsBy.set(k, []); lotsBy.get(k).push(l); }
  const countries = new Map();
  for (const p of P.values()) {
    p._lots = lotsBy.get(p.key) || [];
    p._roasters = [...new Set(p._lots.map(l => l.roaster))].sort(byName);
    p._mapped = Number.isFinite(p.lat) && Number.isFinite(p.lng);
    p._search = fold([p.name, p.full, ...arr(p.aliases), p.country, p.region, ...arr(p.topNotes), ...arr(p.varietals), ...arr(p.processes),
      ...p._lots.flatMap(l => [l.display, l.farm, l.region, l.process, ...l.varieties, ...l.notes])].join(' '));
    if (p.country) { const c = countries.get(p.country) || { name: p.country, producers: 0 }; c.producers++; countries.set(p.country, c); }
  }
  for (const l of LOTS) if (l.country && !countries.has(l.country)) countries.set(l.country, { name: l.country, producers: 0 });
  COUNTRIES = [...countries.values()].sort((a, b) => b.producers - a.producers || byName(a.name, b.name));
  for (const k of [...saved]) if (!P.has(k)) saved.delete(k);
  spreadColocated();
}
// Producers that share a coordinate fan out a little so each stays tappable.
function spreadColocated() {
  const buckets = new Map();
  for (const p of P.values()) if (p._mapped) { const k = p.lng.toFixed(3) + ',' + p.lat.toFixed(3); if (!buckets.has(k)) buckets.set(k, []); buckets.get(k).push(p); }
  for (const g of buckets.values()) {
    g.sort((a, b) => b._lots.length - a._lots.length || byName(a.key, b.key));
    g.forEach((p, i) => { const r = 0.016 * Math.sqrt(i), t = i * 2.39996; p._pt = [p.lng + r * Math.cos(t), p.lat + r * Math.sin(t)]; });
  }
}

/* ---------- filters ---------- */
const F = { roasters: new Set(), country: '', process: '', shop: false, available: false, saved: false };
const lotFiltered = () => F.roasters.size > 0 || !!F.process || F.shop || F.available;
const filtersActive = () => lotFiltered() || !!F.country || F.saved;
function lotOk(l) {
  if (F.roasters.size && !F.roasters.has(l.roaster)) return false;
  if (F.country && l.country !== F.country) return false;
  if (F.process && l.bucket !== F.process) return false;
  if (F.shop && !atEntropica(l)) return false;
  if (F.available && l.availability !== 'available' && !atEntropica(l)) return false;
  return true;
}
function producerOk(p) {
  if (F.saved && !saved.has(p.key)) return false;
  if (lotFiltered()) return p._lots.some(lotOk);
  if (F.country) return p.country === F.country || p._lots.some(lotOk);
  return true;
}
const VIS = { producers: [], lots: [], pset: new Set() };
function computeVisible() {
  VIS.producers = [...P.values()].filter(producerOk);
  VIS.pset = new Set(VIS.producers.map(p => p.key));
  VIS.lots = LOTS.filter(l => lotOk(l) && (!F.saved || l.keys.some(k => saved.has(k))));
}
const visibleLotsOf = p => p._lots.filter(lotOk);
const visibleRoastersOf = p => [...new Set(visibleLotsOf(p).map(l => l.roaster))];

/* ---------- screens and history ----------
   Every entry this page pushes carries {eat: depth}. Popstate reads the address, never a private
   stack, so back, forward and reload all agree with it. The filter picker gets its own entry, so
   Android back closes the picker instead of leaving the page. */
let view = 'globe', screen = { t: 'home' }, query = '', depth = 0, ignorePop = 0;
const scrollAt = new Map();
const same = (a, b) => a.t === b.t && a.k === b.k;
const ownHash = () => !location.hash || /(^|&)(p|r|yours|v)=/.test(location.hash.slice(1));
function hashFor(s) {
  const q = new URLSearchParams();
  if (s.t === 'p') q.set('p', s.k); else if (s.t === 'r') q.set('r', s.k); else if (s.t === 'yours') q.set('yours', '1');
  if (view === 'web') q.set('v', 'web');
  const h = q.toString();
  return location.pathname + location.search + (h ? '#' + h : '');
}
function readHash() {
  const q = new URLSearchParams(location.hash.slice(1));
  if (q.get('p') && P.has(q.get('p'))) return { t: 'p', k: q.get('p') };
  if (q.get('r') && ROASTERS.includes(q.get('r'))) return { t: 'r', k: q.get('r') };
  if (q.get('yours')) return { t: 'yours' };
  return { t: 'home' };
}
function go(next, { push = true, camera = true } = {}) {
  if (document.activeElement === el.q) el.q.blur();
  if (next.t === 'p' && !P.has(next.k)) return;
  if (next.t === 'r' && !ROASTERS.includes(next.k)) return;
  if (push && !same(next, screen)) {
    scrollAt.set(depth, el.body.scrollTop);
    depth++;
    history.pushState({ eat: depth }, '', hashFor(next));
  } else history.replaceState({ eat: depth }, '', hashFor(next));
  show(next, { camera });
}
// The sheet settles first: its padding animation would cancel a camera flight started before it.
function show(next, { camera = true, scroll = 0 } = {}) {
  screen = next;
  renderScreen(scroll);
  const flies = camera && next.t !== 'home';
  if (!wide.matches) setSnap(next.t === 'home' ? (snap === 'full' && !query ? 'half' : snap) : (snap === 'full' ? 'full' : 'half'), { mapEase: !flies });
  highlight(camera);
}
function back() {
  if (depth > 0) history.back();
  else go({ t: 'home' }, { push: false });
}
addEventListener('popstate', e => {
  if (!A) return;
  if (ignorePop) { ignorePop--; return; }
  if (!el.picker.hidden) { hidePicker(); if (same(readHash(), screen)) return; }
  if (e.state?.picker != null) return;
  if (e.state?.eat == null && !ownHash()) return;
  depth = e.state?.eat ?? 0;
  show(readHash(), { scroll: scrollAt.get(depth) || 0 });
});

/* ---------- sheet (phones) ---------- */
let snap = 'peek', visibleH = 0;
const snaps = { peek: 160, half: 400, full: 600 };
const safeProbe = document.createElement('div');
safeProbe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;padding-bottom:env(safe-area-inset-bottom,0px)';
root.append(safeProbe);
const safeBottom = () => parseFloat(getComputedStyle(safeProbe).paddingBottom) || 0;
function measureSheet() {
  if (wide.matches) { el.sheet.style.height = ''; el.sheet.style.transform = ''; root.style.setProperty('--eat-hidden', '0px'); return; }
  const H = root.clientHeight;
  const headH = el.head.offsetHeight;
  const safe = safeBottom();
  snaps.full = Math.max(0, H - 12);
  snaps.peek = Math.min(snaps.full, headH + (screen.t === 'home' ? 48 : 108) + safe);
  snaps.half = Math.round(clamp(H * 0.5, snaps.peek + 80, snaps.full));
  el.sheet.style.height = snaps[snap] + 'px';
  setVisible(snaps[snap], false);
  root.style.setProperty('--eat-hidden', '0px');
}
function setVisible(h, settle = true) {
  visibleH = h;
  el.sheet.classList.toggle('is-settling', settle && !reduced.matches);
  el.sheet.style.height = Math.round(h) + 'px';
  el.sheet.style.transform = 'none';
  root.style.setProperty('--eat-panel-height', Math.round(h) + 'px');
}
function setSnap(name, { mapEase = true } = {}) {
  if (wide.matches) return;
  snap = name;
  root.dataset.snap = name;
  el.stage.inert = name === 'full' || !el.picker.hidden;
  setVisible(snaps[name], true);
  root.style.setProperty('--eat-hidden', '0px');
  const grab = el.sheet.querySelector('.eat-grab');
  const label = name === 'full' ? 'Show map' : name === 'half' ? 'Expand panel' : screen.t === 'home' ? 'Browse producers' : 'Read profile';
  grab?.setAttribute('aria-label', label);
  if (grab) grab.querySelector('span').textContent = label;
  grab?.setAttribute('aria-expanded', name !== 'peek');
  if (mapEase && map && mapReady && view === 'globe') map.easeTo({ padding: mapPadding(), duration: reduced.matches ? 0 : 420, easing: EASE });
  if (view === 'web') { renderMobileWeb(); }
}
function settleFrom(v) {
  const order = ['peek', 'half', 'full'];
  let target;
  if (Math.abs(v) > 0.45) target = v > 0 ? (order.find(s => snaps[s] > visibleH + 8) || 'full') : ([...order].reverse().find(s => snaps[s] < visibleH - 8) || 'peek');
  else target = order.reduce((a, s) => (Math.abs(snaps[s] - visibleH) < Math.abs(snaps[a] - visibleH) ? s : a), 'peek');
  setSnap(target);
}
function velocity(samples) {
  if (samples.length < 2) return 0;
  const a = samples[0], b = samples[samples.length - 1], dt = b.t - a.t;
  return dt > 0 ? (a.y - b.y) / dt : 0;
}
// Drag the head.
let drag = null, swallowClick = false;
el.head.addEventListener('pointerdown', e => {
  if (wide.matches || (e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('input, .eat-chips, .eat-home-heading, .eat-nav')) return;
  drag = { id: e.pointerId, y0: e.clientY, h0: visibleH, moved: false, samples: [{ y: e.clientY, t: e.timeStamp }] };
});
el.head.addEventListener('pointermove', e => {
  if (!drag || e.pointerId !== drag.id) return;
  const dy = e.clientY - drag.y0;
  if (!drag.moved) {
    if (Math.abs(dy) < 7) return;
    drag.moved = true;
    try { el.head.setPointerCapture(e.pointerId); } catch { /* released */ }
    if (document.activeElement === el.q) el.q.blur();
  }
  setVisible(clamp(drag.h0 - dy, snaps.peek - 24, snaps.full), false);
  drag.samples.push({ y: e.clientY, t: e.timeStamp });
  if (drag.samples.length > 5) drag.samples.shift();
});
function endHeadDrag(e) {
  if (!drag || e.pointerId !== drag.id) return;
  if (drag.moved) { swallowClick = true; setTimeout(() => (swallowClick = false), 60); settleFrom(velocity(drag.samples)); }
  drag = null;
}
el.head.addEventListener('pointerup', endHeadDrag);
el.head.addEventListener('pointercancel', endHeadDrag);
el.head.addEventListener('click', e => {
  if (swallowClick) { e.stopPropagation(); e.preventDefault(); swallowClick = false; return; }
  if (!wide.matches && e.target.closest('.eat-grab')) setSnap(snap === 'full' ? 'peek' : snap === 'half' ? 'full' : 'half');
}, true);
el.sheet.querySelector('.eat-grab').addEventListener('keydown', e => {
  if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
  e.preventDefault();
  const order = ['peek', 'half', 'full'];
  setSnap(order[clamp(order.indexOf(snap) + (e.key === 'ArrowUp' ? 1 : -1), 0, 2)]);
});
// Drag from the list: pull down at the top to collapse, push up to expand before scrolling.
let bodyDrag = null;
el.body.addEventListener('touchstart', e => {
  if (wide.matches || e.touches.length !== 1) { bodyDrag = null; return; }
  const t = e.touches[0];
  bodyDrag = { x0: t.clientX, y0: t.clientY, h0: visibleH, active: false, samples: [] };
}, { passive: true });
el.body.addEventListener('touchmove', e => {
  if (!bodyDrag) return;
  const t = e.touches[0], dx = t.clientX - bodyDrag.x0, dy = t.clientY - bodyDrag.y0;
  if (!bodyDrag.active) {
    if (Math.hypot(dx, dy) < 7) return;
    if (Math.abs(dx) > Math.abs(dy)) { bodyDrag = null; return; }
    const atTop = el.body.scrollTop <= 0;
    if ((dy > 0 && atTop && snap !== 'peek') || (dy < 0 && snap !== 'full')) {
      bodyDrag.active = true; bodyDrag.y0 = t.clientY; bodyDrag.h0 = visibleH;
    } else { bodyDrag = null; return; }
  }
  e.preventDefault();
  setVisible(clamp(bodyDrag.h0 - (t.clientY - bodyDrag.y0), snaps.peek - 24, snaps.full), false);
  bodyDrag.samples.push({ y: t.clientY, t: e.timeStamp });
  if (bodyDrag.samples.length > 5) bodyDrag.samples.shift();
}, { passive: false });
function endBodyDrag() {
  if (bodyDrag?.active) settleFrom(velocity(bodyDrag.samples));
  bodyDrag = null;
}
el.body.addEventListener('touchend', endBodyDrag);
el.body.addEventListener('touchcancel', endBodyDrag);
// The root clips; nothing may scroll it. Focus or the keyboard can still try, so put it back.
root.addEventListener('scroll', () => { if (root.scrollTop || root.scrollLeft) root.scrollTop = root.scrollLeft = 0; });

/* ---------- rendering: sheet ---------- */
const roasterOf = name => A.roasters[name] || {};
function altitudeOf(p) {
  if (p.altitude) return /[\d+]$/.test(p.altitude.trim()) ? p.altitude.trim() + ' m' : p.altitude;
  return Array.isArray(p.altRange) ? `${p.altRange[0].toLocaleString('en-US')}–${p.altRange[1].toLocaleString('en-US')} m` : '';
}
function sortLots(lots) {
  const rank = l => (atEntropica(l) ? -1 : l.availability === 'available' ? 0 : l.availability === 'unknown' ? 1 : 2);
  return [...lots].sort((a, b) => rank(a) - rank(b) || byName(a.roaster, b.roaster) || byName(a.display, b.display));
}
function harvestOf(l) {
  if (!l.harvest) return '';
  const m = /^(\d{4})-(\d{2})/.exec(l.harvest);
  return 'Harvest ' + (m ? `${MONTHS[+m[2] - 1]} ${m[1]}` : l.harvest);
}
// "Boquete, Panama" already names the country; do not repeat it.
function placeOf(p) {
  const region = p.region || '', country = p.country || '';
  if (!region) return country;
  return country && !fold(region).includes(fold(country)) ? `${region} · ${country}` : region;
}
/* Producer photos: only those approved in curated/public-photos.json reach the data, hosted in
   Shopify Files. Every large photo carries its credit and a link to where it was published. */
const photoOf = p => (p && p.public_photo && p.public_photo.src ? p.public_photo : null);
const sized = (ph, w) => ph.src + (ph.src.includes('?') ? '&' : '?') + 'width=' + w;
const faceClass = ph => (ph.kind === 'portrait' || ph.kind === 'person' ? ' is-face' : '');
function thumbHTML(p, w = 96) {
  const ph = photoOf(p);
  return ph ? `<img class="eat-thumb${faceClass(ph)}" src="${esc(sized(ph, w))}" alt="" loading="lazy" decoding="async">` : '';
}
// The credit text and its source page were frozen when the photo was approved; the export drops any photo without both.
function creditHTML(ph) {
  const src = urlOf(ph.source);
  return src ? `<a class="eat-credit" href="${esc(src.href)}" target="_blank" rel="noopener noreferrer">${esc(ph.credit)} ${ICON.out}</a>` : '';
}
function heroHTML(p) {
  const ph = photoOf(p);
  if (!ph) return '';
  const alt = ph.caption || `${p.name}. ${ph.credit}`;
  const set = [480, 720, 960, 1400].map(w => `${esc(sized(ph, w))} ${w}w`).join(', ');
  return `<figure class="eat-photo"><img class="${faceClass(ph).trim()}" src="${esc(sized(ph, 960))}" srcset="${set}" sizes="(min-width: 900px) 368px, calc(100vw - 32px)" width="${ph.w}" height="${ph.h}" alt="${esc(alt)}" decoding="async"><figcaption>${creditHTML(ph)}</figcaption></figure>`;
}
function producerRow(p, { note = '' } = {}) {
  const rs = lotFiltered() ? visibleRoastersOf(p) : p._roasters;
  const sub = [placeOf(p), p._lots.some(atEntropica) ? 'At Entropica' : ''].filter(Boolean).join(' · ') || 'Origin not recorded';
  return `<button class="eat-row" data-go-p="${esc(p.key)}">
    <span class="eat-row-main"><span class="eat-row-title">${esc(p.name)}</span><span class="eat-row-sub">${esc(note || sub)}</span></span>
    <span class="eat-row-meta">${thumbHTML(p)}${saved.has(p.key) ? `<span class="eat-row-saved" aria-label="Saved">${ICON.saved}</span>` : ''}${rs.length ? `<span class="eat-count" aria-label="${plural(rs.length, 'roaster')}">${rs.length}<i class="eat-sq" aria-hidden="true"></i></span>` : ''}${ICON.chev}</span>
  </button>`;
}
function peopleStrip() {
  const list = [...P.values()].filter(photoOf).sort((a, b) => b._roasters.length - a._roasters.length || byName(a.name, b.name));
  if (!list.length) return '';
  return `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">People and places</span><span class="eat-plate eat-dim">${list.length}</span></div>
    <div class="eat-strip">${list.map(p => `<button class="eat-pcard eat-glass" data-go-p="${esc(p.key)}"><span class="eat-pcard-img">${thumbHTML(p, 360)}</span><span class="eat-pcard-name">${esc(p.name)}</span><span class="eat-plate">${esc(p.country || '')}</span><span class="eat-pcard-credit">${esc(photoOf(p).credit)}</span></button>`).join('')}</div>
    <p class="eat-small">Open a producer to see each photo's credit and the page it was published on.</p></section>`;
}
function rowsGrouped(list) {
  const counted = list.map(p => ({ p, n: lotFiltered() ? visibleRoastersOf(p).length : p._roasters.length }));
  counted.sort((a, b) => b.n - a.n || b.p._lots.length - a.p._lots.length || byName(a.p.name, b.p.name));
  const groups = [
    ['Listed by several roasters', counted.filter(x => x.n > 1)],
    ['Listed by one roaster', counted.filter(x => x.n === 1)],
    ['No published coffees yet', counted.filter(x => x.n === 0)],
  ].filter(g => g[1].length);
  return groups.map(([title, items]) => `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">${title}</span><span class="eat-plate eat-dim">${items.length}</span></div>
    <div class="eat-rows">${items.map(x => producerRow(x.p)).join('')}</div></section>`).join('');
}
function roasterStrip() {
  const counts = new Map(ROASTERS.map(r => [r, 0]));
  for (const p of P.values()) for (const r of p._roasters) counts.set(r, counts.get(r) + 1);
  const order = [...ROASTERS].sort((a, b) => counts.get(b) - counts.get(a) || byName(a, b));
  return `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Roasters</span><span class="eat-plate eat-dim">${ROASTERS.length}</span></div>
    <div class="eat-strip">${order.map(r => `<button class="eat-card eat-glass" data-go-r="${esc(r)}"><span class="eat-card-title">${esc(r)}</span><span class="eat-plate">${esc(roasterOf(r).city || '')}</span><span class="eat-card-meta">${plural(counts.get(r), 'producer')}</span></button>`).join('')}</div></section>`;
}
function homeHTML() {
  if (query.trim()) return searchHTML(query);
  const any = filtersActive();
  let h = `<div class="eat-sum"><span class="eat-plate">${plural(VIS.producers.length, 'producer')} · ${plural(VIS.lots.length, 'listing')}</span>${any ? '<button class="eat-link" data-clear>Clear filters</button>' : ''}</div>`;
  if (!any) {
    const named = LOTS.filter(l => l.keys.length).length;
    h += `<div class="eat-intro"><h2 class="eat-display">Where the coffee begins</h2>
      <p>Producers named in ${named} of the ${LOTS.length} coffee listings published by ${ROASTERS.length} European roasters. ${globeAvailable ? 'Choose a point on the globe, or open the Web' : 'Open the Web'} to see which producers several roasters list.</p></div>`;
    h += peopleStrip();
    h += roasterStrip();
  }
  h += VIS.producers.length ? rowsGrouped(VIS.producers) : `<div class="eat-empty"><p>No producers match these filters.</p><button class="eat-btn" data-clear>Clear filters</button></div>`;
  h += yoursRow();
  h += `<p class="eat-foot">From the roasters' published listings, checked ${esc(day(A.built) || 'recently')}. Listings change; check the source for current stock.</p>`;
  return h;
}
function yoursRow() {
  const rated = LOTS.filter(l => ratings[l.id] === 1 || ratings[l.id] === -1).length;
  return `<section class="eat-sec"><button class="eat-row eat-row--plain" data-go-yours>
    <span class="eat-row-main"><span class="eat-row-title">Your cups</span><span class="eat-row-sub">${rated ? plural(rated, 'coffee') + ' recorded' : 'Record the coffees you have tasted'}${saved.size ? ' · ' + plural(saved.size, 'saved producer') : ''}</span></span>
    <span class="eat-row-meta">${ICON.chev}</span></button></section>`;
}
function searchHTML(q) {
  const terms = fold(q).split(/\s+/).filter(Boolean);
  const hit = s => terms.every(t => s.includes(t));
  const head = fold(q.trim());
  const producers = VIS.producers.filter(p => hit(p._search))
    .sort((a, b) => (fold(b.name).startsWith(head) - fold(a.name).startsWith(head)) || b._roasters.length - a._roasters.length || byName(a.name, b.name));
  const roasters = ROASTERS.filter(r => VIS.lots.some(l => l.roaster === r) && hit(fold([r, roasterOf(r).city, roasterOf(r).country].join(' '))));
  const countries = COUNTRIES.filter(c => VIS.producers.some(p => p.country === c.name) && hit(fold(c.name)));
  const coffees = VIS.lots.filter(l => hit(l._search));
  if (!producers.length && !roasters.length && !countries.length && !coffees.length)
    return `<div class="eat-empty"><p>Nothing in the atlas matches “${esc(q.trim())}”.</p><p class="eat-small">Try a producer, farm, region, country, variety or tasting note.</p></div>`;
  let h = '';
  if (countries.length) h += `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Origins</span></div><div class="eat-tags">${countries.slice(0, 8).map(c => `<button class="eat-tag" data-country="${esc(c.name)}">${esc(c.name)}<span>${c.producers}</span></button>`).join('')}</div></section>`;
  if (roasters.length) h += `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Roasters</span></div><div class="eat-rows">${roasters.map(r => `<button class="eat-row" data-go-r="${esc(r)}"><span class="eat-row-main"><span class="eat-row-title">${esc(r)}</span><span class="eat-row-sub">${esc([roasterOf(r).city, roasterOf(r).country].filter(Boolean).join(' · '))}</span></span><span class="eat-row-meta">${ICON.chev}</span></button>`).join('')}</div></section>`;
  if (producers.length) h += `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Producers</span><span class="eat-plate eat-dim">${producers.length}</span></div><div class="eat-rows">${producers.slice(0, 40).map(p => producerRow(p)).join('')}</div></section>`;
  if (coffees.length) h += `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Coffees</span><span class="eat-plate eat-dim">${coffees.length}</span></div><div class="eat-rows">${sortLots(coffees).slice(0, 30).map(l => `<button class="eat-row" ${l.keys[0] ? `data-go-p="${esc(l.keys[0])}" data-lot="${esc(l.id)}"` : `data-go-r="${esc(l.roaster)}"`}><span class="eat-row-main"><span class="eat-row-title">${esc(l.display)}</span><span class="eat-row-sub">${esc([l.roaster, l.country].filter(Boolean).join(' · '))}</span></span><span class="eat-row-meta">${ICON.chev}</span></button>`).join('')}</div></section>`;
  return h;
}
const atEntropica = l => !!l.shop && l.store_availability === 'available';
function statusHTML(l) {
  if (l.shop) {
    const when = day(l.store_checked_at);
    return atEntropica(l) ? '<span class="eat-status is-on">At Entropica</span>' : `<span class="eat-status">Not available at Entropica${when ? ' · ' + when : ''}</span>`;
  }
  const when = day(l.checked_at);
  if (l.availability === 'available') return `<span class="eat-status is-on">Listed available${when ? ' · checked ' + when : ''}</span>`;
  if (l.availability === 'unavailable') return `<span class="eat-status">Sold out at last check${when ? ' · ' + when : ''}</span>`;
  return '<span class="eat-status">Availability not listed</span>';
}
function coffeeHTML(l, { producer = false } = {}) {
  const facts = [l.process, l.varieties.join(', '), harvestOf(l)].filter(Boolean);
  const prod = producer && l.keys[0] ? P.get(l.keys[0]) : null;
  const r = ratings[l.id];
  return `<article class="eat-coffee eat-glass" data-lot="${esc(l.id)}">
    <div class="eat-coffee-top"><span class="eat-plate">${esc(l.roaster)}</span>${statusHTML(l)}</div>
    <h3 class="eat-coffee-title">${esc(l.display)}</h3>
    ${prod ? `<button class="eat-link eat-coffee-prod" data-go-p="${esc(prod.key)}">${esc(prod.name)}</button>` : ''}
    ${facts.length ? `<p class="eat-coffee-facts">${esc(facts.join(' · '))}</p>` : ''}
    ${l.notes.length ? `<p class="eat-coffee-notes">${esc(l.notes.join(' · '))}</p>` : ''}
    ${l.inferred ? '<p class="eat-small">Producer inferred from the listing text.</p>' : ''}
    ${atEntropica(l) ? `<div class="eat-coffee-actions"><a class="eat-btn eat-btn--primary" href="${esc(l.shop)}">View at Entropica</a></div>`
      : l.source ? `<a class="eat-srclink" href="${esc(l.source)}" target="_blank" rel="noopener noreferrer">Source: ${esc(l.roaster)} listing ${ICON.out}</a>` : ''}
    <div class="eat-taste" role="group" aria-label="Your experience with ${esc(l.display)}">
      <button class="eat-taste-btn" data-taste="1" data-taste-lot="${esc(l.id)}" aria-pressed="${r === 1}">Enjoyed it</button>
      <button class="eat-taste-btn" data-taste="-1" data-taste-lot="${esc(l.id)}" aria-pressed="${r === -1}">Not for me</button>
    </div>
  </article>`;
}
const PRECISION = { farm: 'Mapped to the farm', station: 'Mapped to the washing station', town: 'Mapped to the nearest town', region: 'Mapped to the region', country: 'Mapped to the country' };
function producerHTML(p) {
  const lots = sortLots(p._lots);
  const here = lots.filter(atEntropica).length;
  const avail = here || lots.filter(l => l.availability === 'available').length;
  const where = [p.region, altitudeOf(p)].filter(Boolean).join(' · ');
  const location = [p.region, p.country].filter(Boolean).join(', ');
  const desc = p.public_description && p.public_description !== `Coffee producer based in ${location}.` ? p.public_description : '';
  const site = urlOf(p.website);
  const chips = list => list.map(x => `<span class="eat-tag eat-tag--static">${esc(x)}</span>`).join('');
  return `<header class="eat-hero">
      <div class="eat-plate">Producer${p.country ? ' · ' + esc(p.country) : ''}</div>
      <h1 class="eat-title">${esc(p.name)}</h1>
      ${where ? `<p class="eat-where">${esc(where)}</p>` : ''}
      ${PRECISION[p.precision] ? `<p class="eat-small">${PRECISION[p.precision]}.</p>` : ''}
    </header>
    ${heroHTML(p)}
    <div class="eat-stats eat-glass">
      <div><b>${p._roasters.length}</b><span class="eat-plate">${p._roasters.length === 1 ? 'Roaster' : 'Roasters'}</span></div>
      <div><b>${lots.length}</b><span class="eat-plate">${lots.length === 1 ? 'Listing' : 'Listings'}</span></div>
      <div><b>${avail}</b><span class="eat-plate">${here ? 'At Entropica' : 'Listed available'}</span></div>
    </div>
    ${desc ? `<section class="eat-sec"><p class="eat-prose">${esc(desc)}</p></section>` : ''}
    ${p._roasters.length ? `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Roasters listing this producer</span></div>
      <div class="eat-tags">${p._roasters.map(r => `<button class="eat-tag" data-go-r="${esc(r)}"><i class="eat-sq" aria-hidden="true"></i>${esc(r)}</button>`).join('')}</div></section>` : ''}
    ${arr(p.processes).length || arr(p.varietals).length ? `<section class="eat-sec eat-sec--pair">
      ${arr(p.processes).length ? `<div><div class="eat-plate">Processes</div><div class="eat-tags">${chips(p.processes)}</div></div>` : ''}
      ${arr(p.varietals).length ? `<div><div class="eat-plate">Varieties</div><div class="eat-tags">${chips(p.varietals)}</div></div>` : ''}</section>` : ''}
    ${arr(p.topNotes).length ? `<section class="eat-sec"><div class="eat-plate">Notes across these coffees</div><p class="eat-prose">${esc(p.topNotes.join(' · '))}</p></section>` : ''}
    <section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Coffees</span><span class="eat-plate eat-dim">${lots.length}</span></div>
      ${lots.length ? `<div class="eat-coffees">${lots.map(l => coffeeHTML(l)).join('')}</div>` : '<p class="eat-small">No published coffees from this producer yet.</p>'}</section>
    ${site ? `<section class="eat-sec"><a class="eat-btn" href="${esc(site.href)}" target="_blank" rel="noopener noreferrer">Producer website ${ICON.out}</a></section>` : ''}
    <p class="eat-foot">A line joins a producer to each roaster that lists its coffee. It does not show a direct trading relationship.</p>`;
}
function roasterHTML(r) {
  const ro = roasterOf(r);
  const lots = LOTS.filter(l => l.roaster === r);
  const prods = [...P.values()].filter(p => p._roasters.includes(r));
  const shared = prods.filter(p => p._roasters.length > 1).sort((a, b) => b._roasters.length - a._roasters.length || byName(a.name, b.name));
  const origins = new Map();
  for (const l of lots) if (l.country) origins.set(l.country, (origins.get(l.country) || 0) + 1);
  const ori = [...origins].sort((a, b) => b[1] - a[1] || byName(a[0], b[0]));
  const max = ori[0]?.[1] || 1;
  const byCountry = new Map();
  for (const p of prods) { const c = p.country || 'Origin not recorded'; if (!byCountry.has(c)) byCountry.set(c, []); byCountry.get(c).push(p); }
  const groups = [...byCountry].sort((a, b) => b[1].length - a[1].length || byName(a[0], b[0]));
  const unnamed = sortLots(lots.filter(l => !l.keys.length));
  const site = urlOf(ro.site);
  return `<header class="eat-hero">
      <div class="eat-plate">Roaster${ro.city ? ' · ' + esc([ro.city, ro.country].filter(Boolean).join(', ')) : ''}</div>
      <h1 class="eat-title">${esc(r)}</h1>
    </header>
    <div class="eat-stats eat-glass">
      <div><b>${prods.length}</b><span class="eat-plate">Producers</span></div>
      <div><b>${lots.length}</b><span class="eat-plate">Listings</span></div>
      <div><b>${ori.length}</b><span class="eat-plate">Origins</span></div>
    </div>
    ${ori.length ? `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Listings by origin</span></div>
      <div class="eat-bars">${ori.map(([c, n]) => `<button class="eat-bar" data-country="${esc(c)}"><span class="eat-bar-label">${esc(c)}</span><span class="eat-bar-track"><span style="--w:${(n / max * 100).toFixed(1)}%"></span></span><span class="eat-bar-n">${n}</span></button>`).join('')}</div></section>` : ''}
    ${shared.length ? `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Shared with other roasters</span><span class="eat-plate eat-dim">${shared.length}</span></div>
      <div class="eat-rows">${shared.map(p => producerRow(p, { note: 'Also: ' + p._roasters.filter(x => x !== r).join(', ') })).join('')}</div></section>` : ''}
    ${groups.map(([c, ps]) => `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">${esc(c)}</span><span class="eat-plate eat-dim">${ps.length}</span></div>
      <div class="eat-rows">${ps.sort((a, b) => byName(a.name, b.name)).map(p => producerRow(p)).join('')}</div></section>`).join('')}
    ${unnamed.length ? `<section class="eat-sec"><details class="eat-more"><summary><span class="eat-plate">Coffees with no named producer</span><span class="eat-plate eat-dim">${unnamed.length}</span></summary>
      <div class="eat-coffees">${unnamed.map(l => coffeeHTML(l)).join('')}</div></details></section>` : ''}
    ${site ? `<section class="eat-sec"><a class="eat-btn" href="${esc(site.href)}" target="_blank" rel="noopener noreferrer">Visit ${esc(r)} ${ICON.out}</a></section>` : ''}`;
}
function yoursHTML() {
  const rated = LOTS.filter(l => ratings[l.id] === 1 || ratings[l.id] === -1);
  const liked = rated.filter(l => ratings[l.id] === 1);
  const weight = new Map();
  for (const l of rated) for (const n of l.notes) { const k = fold(n); weight.set(k, (weight.get(k) || { n, w: 0 })); weight.get(k).w += ratings[l.id]; }
  const notes = [...weight.values()].filter(x => x.w > 0).sort((a, b) => b.w - a.w).slice(0, 8);
  const ratedProducers = new Set(rated.flatMap(l => l.keys));
  const similar = notes.length ? [...P.values()].filter(p => !ratedProducers.has(p.key)).map(p => {
    const shared = arr(p.topNotes).filter(n => (weight.get(fold(n))?.w || 0) > 0);
    return { p, shared, score: shared.reduce((s, n) => s + weight.get(fold(n)).w, 0) };
  }).filter(x => x.score > 0).sort((a, b) => b.score - a.score || byName(a.p.name, b.p.name)).slice(0, 6) : [];
  const savedList = [...saved].map(k => P.get(k)).filter(Boolean).sort((a, b) => byName(a.name, b.name));
  return `<header class="eat-hero"><div class="eat-plate">Kept in this browser</div><h1 class="eat-title">Your cups</h1>
      <p class="eat-small">Mark a coffee Enjoyed it or Not for me on any producer page. Saved producers and ratings stay on this device. Clearing browser data removes them.</p></header>
    <div class="eat-stats eat-glass"><div><b>${liked.length}</b><span class="eat-plate">Enjoyed</span></div><div><b>${rated.length - liked.length}</b><span class="eat-plate">Not for me</span></div><div><b>${savedList.length}</b><span class="eat-plate">Saved</span></div></div>
    ${savedList.length ? `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Saved producers</span></div><div class="eat-rows">${savedList.map(p => producerRow(p)).join('')}</div></section>` : ''}
    ${notes.length ? `<section class="eat-sec"><div class="eat-plate">Notes you return to</div><div class="eat-tags">${notes.map(x => `<span class="eat-tag eat-tag--static">${esc(x.n)}</span>`).join('')}</div>
      <p class="eat-small">From the listed tasting notes of coffees you enjoyed. A shared description is a lead, not a prediction.</p></section>` : ''}
    ${similar.length ? `<section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Producers with similar notes</span></div><div class="eat-rows">${similar.map(x => producerRow(x.p, { note: 'Shares ' + x.shared.slice(0, 3).join(', ') })).join('')}</div></section>` : ''}
    <section class="eat-sec"><div class="eat-sec-head"><span class="eat-plate">Coffees you recorded</span><span class="eat-plate eat-dim">${rated.length}</span></div>
      ${rated.length ? `<div class="eat-coffees">${sortLots(rated).map(l => coffeeHTML(l, { producer: true })).join('')}</div>` : '<p class="eat-small">None yet. Open a producer, find a coffee you have tried, and mark it.</p>'}</section>`;
}
function renderChips() {
  const n = F.roasters.size + Number(!!F.country) + Number(!!F.process) + Number(F.available) + Number(F.saved) + Number(F.shop);
  el.chips.innerHTML = `<button class="eat-chip${n ? ' is-set' : ''}" data-pick="all" aria-haspopup="dialog">Filters${n ? ` <span class="eat-filter-count">${n}</span>` : ''}${ICON.caret}</button>
    <button class="eat-chip" data-toggle="shop" aria-pressed="${F.shop}">At Entropica</button>`;
}
function renderNav() {
  const s = screen;
  let title = '', actions = '';
  if (s.t === 'p') {
    const p = P.get(s.k), on = saved.has(p.key);
    title = p.name;
    actions = `<button class="eat-icon-btn" data-save="${esc(p.key)}" aria-pressed="${on}" aria-label="${on ? 'Remove from saved' : 'Save producer'}">${on ? ICON.saved : ICON.save}</button><button class="eat-icon-btn" data-share aria-label="Share">${ICON.share}</button>`;
  } else if (s.t === 'r') { title = s.k; actions = `<button class="eat-icon-btn" data-share aria-label="Share">${ICON.share}</button>`; }
  else if (s.t === 'yours') title = 'Your cups';
  el.navTitle.textContent = title;
  el.navActions.innerHTML = actions;
}
function renderScreen(scroll) {
  const detail = screen.t !== 'home';
  root.dataset.screen = detail ? 'detail' : 'home';
  el.search.hidden = el.chips.hidden = detail;
  el.nav.hidden = !detail;
  if (detail) renderNav();
  el.body.innerHTML = screen.t === 'p' ? producerHTML(P.get(screen.k)) : screen.t === 'r' ? roasterHTML(screen.k) : screen.t === 'yours' ? yoursHTML() : homeHTML();
  el.body.scrollTop = scroll || 0;
  measureSheet();
  announce();
}
function renderBody() { if (screen.t !== 'home') return; const top = el.body.scrollTop; el.body.innerHTML = homeHTML(); el.body.scrollTop = top; announce(); }
// One short line for screen readers instead of re-reading the whole list on every change.
function announce() {
  const s = screen;
  el.status.textContent = s.t === 'p' ? P.get(s.k).name : s.t === 'r' ? s.k : s.t === 'yours' ? 'Your cups'
    : query.trim() ? `Results for ${query.trim()}` : `${plural(VIS.producers.length, 'producer')}, ${plural(VIS.lots.length, 'listing')}`;
}
// Scroll the sheet's list, never the page, to a child.
function scrollBodyTo(node) {
  if (!node) return;
  const top = node.getBoundingClientRect().top - el.body.getBoundingClientRect().top + el.body.scrollTop;
  el.body.scrollTop = Math.max(0, top - 24);
}

/* ---------- filters: picker ---------- */
let pickerKind = '', pickerReturn = null;
function countLots(mut) {
  const keep = { roasters: new Set(F.roasters), country: F.country, process: F.process, shop: F.shop, available: F.available };
  mut();
  const n = LOTS.filter(l => lotOk(l) && (!F.saved || l.keys.some(k => saved.has(k)))).length;
  Object.assign(F, keep);
  return n;
}
function openPicker(kind, trigger) {
  const firstOpen = el.picker.hidden;
  pickerKind = kind; if (firstOpen) pickerReturn = trigger;
  let title = '', options = [], multi = false, note = '';
  const coffees = n => plural(n, 'listing');
  if (kind === 'all') {
    el.picker.innerHTML = `<div class="eat-picker-head"><h2 class="eat-picker-title" id="eat-picker-title">Filter the atlas</h2><button class="eat-btn eat-btn--small" data-picker-done>Done</button></div>
      <div class="eat-picker-body"><p class="eat-small">Narrow the globe, connections and producer list.</p>
      ${[['roaster', 'Roaster', [...F.roasters].join(', ') || 'All roasters'], ['origin', 'Origin', F.country || 'All origins'], ['process', 'Process', F.process || 'Any process']].map(([k, label, value]) => `<button class="eat-filter-row" data-pick="${k}"><span>${label}<small>${esc(value)}</small></span>${ICON.chev}</button>`).join('')}
      ${[['shop', 'At Entropica', 'Coffees available in our store'], ['available', 'Listed available', 'Available at the last source check'], ['saved', 'Saved producers', 'Kept on this device']].map(([k, label, sub]) => `<button class="eat-opt" role="checkbox" aria-checked="${F[k]}" data-filter-toggle="${k}"><span class="eat-opt-mark" aria-hidden="true"></span><span class="eat-opt-main"><span>${label}</span><small>${sub}</small></span></button>`).join('')}
      <div class="eat-filter-footer"><button class="eat-link" data-filter-reset>Clear all</button><button class="eat-btn eat-btn--primary" data-picker-done>Show ${plural(VIS.producers.length, 'producer')}</button></div></div>`;
    revealPicker(trigger);
    return;
  }
  if (kind === 'roaster') {
    title = 'Roaster'; multi = true;
    options = ROASTERS.map(r => ({ v: r, label: r, sub: [roasterOf(r).city, coffees(countLots(() => { F.roasters = new Set([r]); }))].filter(Boolean).join(' · '), on: F.roasters.has(r) }));
  } else if (kind === 'origin') {
    title = 'Origin';
    options = [{ v: '', label: 'All origins', on: !F.country }, ...COUNTRIES.map(c => ({ v: c.name, label: c.name, sub: `${plural(c.producers, 'producer')} · ${coffees(countLots(() => { F.country = c.name; }))}`, on: F.country === c.name }))];
  } else {
    title = 'Process';
    const listed = LOTS.filter(l => l.bucket).length;
    note = `Process is stated in ${listed} of ${LOTS.length} listings.`;
    options = [{ v: '', label: 'Any process', on: !F.process }, ...PROCESSES.map(x => ({ v: x, label: x, n: countLots(() => { F.process = x; }), on: F.process === x })).filter(o => o.n > 0 || o.on).map(o => ({ ...o, sub: o.n != null ? coffees(o.n) : '', n: null }))];
  }
  el.picker.innerHTML = `<div class="eat-picker-head"><button class="eat-back" data-picker-all>${ICON.back}Filters</button><h2 class="eat-picker-title" id="eat-picker-title">${title}</h2>
      <span class="eat-picker-actions">${multi ? '<button class="eat-link" data-picker-clear>Clear</button>' : ''}<button class="eat-btn eat-btn--small" data-picker-done>Done</button></span></div>
    ${note ? `<p class="eat-small eat-picker-note">${esc(note)}</p>` : ''}
    <div class="eat-picker-body" role="${multi ? 'group' : 'radiogroup'}" aria-labelledby="eat-picker-title">${options.map(o => `<button class="eat-opt" role="${multi ? 'checkbox' : 'radio'}" aria-checked="${o.on}" data-opt="${esc(o.v)}">
      <span class="eat-opt-mark" aria-hidden="true"></span><span class="eat-opt-main"><span>${esc(o.label)}</span>${o.sub ? `<small>${esc(o.sub)}</small>` : ''}</span>${o.n != null ? `<span class="eat-opt-n">${o.n}</span>` : ''}</button>`).join('')}</div>`;
  revealPicker(trigger);
}
function revealPicker(trigger) {
  if (document.activeElement === el.q) el.q.blur();
  el.picker.hidden = el.scrim.hidden = false;
  el.stage.inert = el.sheet.inert = true;
  if (history.state?.picker == null) history.pushState({ eat: depth, picker: pickerKind }, '', location.href);
  requestAnimationFrame(() => root.classList.add('is-picking'));
  el.picker.querySelector('button')?.focus({ preventScroll: true });
}
// Closing from the UI also unwinds the picker's history entry; the popstate that causes is ignored.
function closePicker() {
  if (el.picker.hidden) return;
  hidePicker();
  if (history.state?.picker != null) { ignorePop++; history.back(); }
}
function hidePicker() {
  root.classList.remove('is-picking');
  el.picker.hidden = el.scrim.hidden = true;
  el.sheet.inert = false;
  el.stage.inert = !wide.matches && snap === 'full';
  const back = pickerReturn?.isConnected ? pickerReturn : el.chips.querySelector('[data-pick="all"]');
  back?.focus({ preventScroll: true });
  pickerKind = '';
}
el.picker.addEventListener('keydown', e => {
  if (e.key !== 'Tab') return;
  const items = [...el.picker.querySelectorAll('button')];
  if (!items.length) return;
  const first = items[0], last = items[items.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
function pick(v) {
  if (pickerKind === 'roaster') {
    F.roasters.has(v) ? F.roasters.delete(v) : F.roasters.add(v);
    el.picker.querySelector(`[data-opt="${CSS.escape(v)}"]`)?.setAttribute('aria-checked', F.roasters.has(v));
    filtersChanged({ frame: F.roasters.size === 1 ? 'roaster' : '' });
    return;
  }
  if (pickerKind === 'origin') { F.country = v; filtersChanged({ frame: v ? 'country' : 'world' }); openPicker('all'); return; }
  F.process = v; filtersChanged(); openPicker('all');
}
function filtersChanged({ frame = '' } = {}) {
  computeVisible();
  renderChips();
  if (screen.t === 'home') renderBody();
  updateMapData();
  if (view === 'web') webBuild();
  if (frame === 'country' && F.country) frameCountry(F.country);
  else if (frame === 'roaster' && F.roasters.size === 1) frameRoaster([...F.roasters][0]);
  else if (frame === 'world') frameWorld();
  measureSheet();
}
function clearFilters() {
  F.roasters.clear(); F.country = ''; F.process = ''; F.shop = false; F.available = false; F.saved = false;
  filtersChanged({ frame: 'world' });
}

/* ---------- events ---------- */
let qTimer = 0;
el.q.addEventListener('input', () => {
  el.qClear.hidden = !el.q.value;
  clearTimeout(qTimer);
  qTimer = setTimeout(() => { query = el.q.value; if (screen.t === 'home') { el.body.innerHTML = homeHTML(); el.body.scrollTop = 0; announce(); } }, 90);
});
el.q.addEventListener('focus', () => { if (!wide.matches && snap !== 'full') setSnap('full'); });
el.q.addEventListener('keydown', e => { if (e.key === 'Enter') el.q.blur(); if (e.key === 'Escape') { el.q.value = ''; el.q.dispatchEvent(new Event('input')); } });
el.qClear.addEventListener('click', () => { el.q.value = ''; query = ''; el.qClear.hidden = true; el.body.innerHTML = homeHTML(); el.q.focus(); });
el.scrim.addEventListener('click', closePicker);
el.body.addEventListener('scroll', () => root.classList.toggle('is-scrolled', screen.t !== 'home' && el.body.scrollTop > 70), { passive: true });
root.addEventListener('click', e => {
  const t = e.target.closest('button, a');
  if (!t || !A) return;
  const d = t.dataset;
  if (d.goP) { e.preventDefault(); go({ t: 'p', k: d.goP }); if (d.lot) requestAnimationFrame(() => scrollBodyTo(el.body.querySelector(`[data-lot="${CSS.escape(d.lot)}"]`))); return; }
  if (d.goR) { e.preventDefault(); go({ t: 'r', k: d.goR }); return; }
  if ('goYours' in d) { go({ t: 'yours' }); return; }
  if ('back' in d) { back(); return; }
  if (d.view) { setView(d.view); return; }
  if ('recenter' in d) { view === 'globe' ? recenterGlobe() : webReset(); return; }
  if (d.pick) { openPicker(d.pick, t); return; }
  if ('pickerAll' in d) { openPicker('all'); return; }
  if (d.filterToggle) { F[d.filterToggle] = !F[d.filterToggle]; filtersChanged(); openPicker('all'); $(`[data-filter-toggle="${d.filterToggle}"]`)?.focus({preventScroll:true}); return; }
  if ('filterReset' in d) { clearFilters(); openPicker('all'); return; }
  if (d.webPage) { mobileWeb.page += Number(d.webPage); renderMobileWeb(); ($(`button[data-web-page="${d.webPage}"]:not(:disabled)`) || $('.eat-network-pager button:not(:disabled)'))?.focus({preventScroll:true}); return; }
  if (d.zoom) {
    if (view === 'globe' && mapReady) d.zoom === 'in' ? map.zoomIn({duration: reduced.matches ? 0 : 250}) : map.zoomOut({duration: reduced.matches ? 0 : 250});
    else if (view === 'web' && wide.matches) webAnimate(...webZoomAt(web.k * (d.zoom === 'in' ? 1.5 : 1 / 1.5), web.w / 2, web.h / 2));
    return;
  }
  if (d.toggle) { F[d.toggle] = !F[d.toggle]; filtersChanged(); return; }
  if ('clear' in d) { clearFilters(); return; }
  if (d.country) {
    F.country = d.country; query = ''; el.q.value = ''; el.qClear.hidden = true;
    if (screen.t !== 'home') go({ t: 'home' }, { camera: false });
    if (!wide.matches) setSnap('half', { mapEase: false });
    filtersChanged({ frame: 'country' });
    return;
  }
  if (d.opt != null && t.classList.contains('eat-opt')) { pick(d.opt); return; }
  if ('pickerDone' in d) { if (pickerKind !== 'all') openPicker('all'); else closePicker(); return; }
  if ('pickerClear' in d) { F.roasters.clear(); el.picker.querySelectorAll('.eat-opt').forEach(o => o.setAttribute('aria-checked', 'false')); filtersChanged({ frame: 'world' }); return; }
  if (d.save) { toggleSave(d.save); return; }
  if ('share' in d) { share(); return; }
  if (d.tasteLot) { rate(d.tasteLot, Number(d.taste)); return; }
});
root.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (!el.picker.hidden) { closePicker(); e.stopPropagation(); }
  else if (screen.t !== 'home' && !e.target.closest('input')) back();
});
function toggleSave(key) {
  saved.has(key) ? saved.delete(key) : saved.add(key);
  toast(!persist() ? NOT_KEPT : saved.has(key) ? 'Saved on this device' : 'Removed from saved');
  renderChips();
  if (screen.t === 'p') renderNav();
  if (F.saved) filtersChanged();
}
function rate(id, v) {
  if (ratings[id] === v) delete ratings[id]; else ratings[id] = v;
  const kept = persist();
  root.querySelectorAll(`[data-taste-lot="${CSS.escape(id)}"]`).forEach(b => b.setAttribute('aria-pressed', ratings[id] === Number(b.dataset.taste)));
  toast(!kept ? NOT_KEPT : ratings[id] ? 'Recorded in Your cups' : 'Removed from Your cups');
}
async function share() {
  const s = screen, name = s.t === 'p' ? P.get(s.k).name : s.k;
  const url = location.origin + hashFor(s).replace(/([#&])v=web/, '$1').replace(/[#&]$/, '');
  try {
    if (navigator.share) await navigator.share({ title: `${name} · Entropica Producer Atlas`, url });
    else { await navigator.clipboard.writeText(url); toast('Link copied'); }
  } catch (err) { if (err?.name !== 'AbortError') toast('Copy the page address to share'); }
}
function toast(text) {
  el.toast.textContent = text;
  el.toast.hidden = false;
  clearTimeout(toast.t);
  toast.t = setTimeout(() => (el.toast.hidden = true), 2200);
}

/* ---------- views ---------- */
function setView(v, { replace = true } = {}) {
  if (v === 'globe' && !globeAvailable) v = 'web';
  if (v !== 'globe') { map?.stop(); el.map.classList.remove('is-dragging'); }
  view = v;
  root.dataset.view = v;
  root.querySelectorAll('button[data-view]').forEach(b => b.setAttribute('aria-pressed', b.dataset.view === v));
  el.web.toggleAttribute('hidden', v !== 'web');
  el.caption.innerHTML = v === 'web'
    ? '<span><i class="eat-sq"></i>Roasters on the ring</span><span><i class="eat-k-dot"></i>Producers they share</span><span><i class="eat-k-dot is-dim"></i>One roaster</span>'
    : '<span><i class="eat-k-dot"></i>Producer</span><span><i class="eat-k-ring"></i>Several roasters</span><span><i class="eat-sq"></i>Roaster</span><span><i class="eat-k-dot is-dim"></i>No current listings</span>';
  if (replace && A) history.replaceState(history.state, '', hashFor(screen));
  if (v === 'web') {
    webBuild();
    renderMobileWeb();
    if (A && wide.matches && !local.get('entropica-explore-web-hint', false)) { local.set('entropica-explore-web-hint', true); toast(finePointer.matches ? 'Scroll to zoom. Click a name to open it.' : 'Pinch to zoom. Tap a name to open it.'); }
  }
  else { initMap(); if (map) { map.resize(); } }
  hideTip();
}

/* ---------- globe ---------- */
let map = null, mapReady = false, globeAvailable = true;
const NONE = ['==', ['literal', 1], ['literal', 0]];
function webglOk() { try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch { return false; } }
function mapPadding() {
  if (wide.matches) return { top: 72, bottom: 24, left: 24, right: 24 };
  const sv = Math.min(visibleH || snaps.peek, snaps.half);
  return { top: 110, bottom: Math.max(0, sv + 16), left: 20, right: 20 };
}
function globeZoom() {
  const r = el.map.getBoundingClientRect(), p = mapPadding();
  const d = Math.max(150, Math.min(r.width - p.left - p.right, r.height - p.top - p.bottom)) * 0.94;
  return Math.log2(d * Math.PI / 512);
}
function producersGeo() {
  return { type: 'FeatureCollection', features: VIS.producers.filter(p => p._mapped).map(p => {
    const n = lotFiltered() ? visibleLotsOf(p).length : p._lots.length;
    const rc = lotFiltered() ? visibleRoastersOf(p).length : p._roasters.length;
    return { type: 'Feature', properties: { key: p.key, name: p.name, n, rc }, geometry: { type: 'Point', coordinates: p._pt } };
  }) };
}
function arcsGeo() {
  const f = [];
  for (const p of VIS.producers) {
    if (!p._mapped) continue;
    const per = {};
    for (const l of visibleLotsOf(p)) per[l.roaster] = (per[l.roaster] || 0) + 1;
    for (const [r, n] of Object.entries(per)) {
      const ro = roasterOf(r);
      if (!Number.isFinite(ro.lng)) continue;
      f.push({ type: 'Feature', properties: { p: p.key, r, n }, geometry: { type: 'LineString', coordinates: greatCircle(p._pt, [ro.lng, ro.lat]) } });
    }
  }
  return { type: 'FeatureCollection', features: f };
}
function roastersGeo() {
  return { type: 'FeatureCollection', features: ROASTERS.filter(r => (!F.roasters.size || F.roasters.has(r)) && Number.isFinite(roasterOf(r).lng))
    .map(r => ({ type: 'Feature', properties: { r }, geometry: { type: 'Point', coordinates: [roasterOf(r).lng, roasterOf(r).lat] } })) };
}
function greatCircle(a, b, n = 48) {
  const l1 = a[0] * D2R, p1 = a[1] * D2R, l2 = b[0] * D2R, p2 = b[1] * D2R;
  const w = 2 * Math.asin(Math.sqrt(Math.sin((p2 - p1) / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin((l2 - l1) / 2) ** 2));
  if (!w) return [a, b];
  const out = []; let prev = null;
  for (let i = 0; i <= n; i++) {
    const f = i / n, s1 = Math.sin((1 - f) * w) / Math.sin(w), s2 = Math.sin(f * w) / Math.sin(w);
    const x = s1 * Math.cos(p1) * Math.cos(l1) + s2 * Math.cos(p2) * Math.cos(l2);
    const y = s1 * Math.cos(p1) * Math.sin(l1) + s2 * Math.cos(p2) * Math.sin(l2);
    const z = s1 * Math.sin(p1) + s2 * Math.sin(p2);
    let lng = Math.atan2(y, x) / D2R;
    if (prev !== null) { while (lng - prev > 180) lng -= 360; while (lng - prev < -180) lng += 360; }
    prev = lng; out.push([lng, Math.atan2(z, Math.hypot(x, y)) / D2R]);
  }
  return out;
}
function graticule() {
  const f = [], line = (k, coords) => f.push({ type: 'Feature', properties: { k }, geometry: { type: 'LineString', coordinates: coords } });
  for (let lng = -180; lng < 180; lng += 30) line('g', Array.from({ length: 33 }, (_, i) => [lng, -80 + i * 5]));
  for (let lat = -60; lat <= 60; lat += 30) line(lat === 0 ? 'eq' : 'g', Array.from({ length: 73 }, (_, i) => [-180 + i * 5, lat]));
  for (const lat of [23.44, -23.44]) line('tropic', Array.from({ length: 73 }, (_, i) => [-180 + i * 5, lat]));
  return { type: 'FeatureCollection', features: f };
}
function squareImage(filled) {
  const s = 22, c = document.createElement('canvas'); c.width = c.height = s;
  const g = c.getContext('2d');
  g.fillStyle = filled ? '#f9f9f9' : '#030303'; g.fillRect(4, 4, 14, 14);
  g.strokeStyle = '#f9f9f9'; g.lineWidth = 2; g.strokeRect(5, 5, 12, 12);
  return g.getImageData(0, 0, s, s);
}
function mapStyle() {
  const NAME = ['coalesce', ['get', 'name:en'], ['get', 'name_en'], ['get', 'name']], FONT = ['Noto Sans Regular'];
  return {
    version: 8, projection: { type: 'globe' },
    glyphs: 'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf',
    sky: { 'sky-color': '#030303', 'horizon-color': '#0a0a0a', 'fog-color': '#030303', 'atmosphere-blend': ['interpolate', ['linear'], ['zoom'], 0, 0.3, 4, 0.08, 6, 0] },
    sources: {
      omt: { type: 'vector', url: 'https://tiles.openfreemap.org/planet', attribution: '<a href="https://openfreemap.org" target="_blank" rel="noopener">OpenFreeMap</a> © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' },
      grat: { type: 'geojson', data: graticule() },
      arcs: { type: 'geojson', data: arcsGeo() },
      roasters: { type: 'geojson', data: roastersGeo() },
      producers: { type: 'geojson', data: producersGeo() },
    },
    layers: [
      { id: 'land', type: 'background', paint: { 'background-color': '#0f0f0f' } },
      { id: 'water', type: 'fill', source: 'omt', 'source-layer': 'water', paint: { 'fill-color': '#030303' } },
      { id: 'grat', type: 'line', source: 'grat', filter: ['==', ['get', 'k'], 'g'], paint: { 'line-color': '#151515', 'line-width': 0.5 } },
      { id: 'equator', type: 'line', source: 'grat', filter: ['==', ['get', 'k'], 'eq'], paint: { 'line-color': '#262626', 'line-width': 0.7 } },
      { id: 'tropics', type: 'line', source: 'grat', filter: ['==', ['get', 'k'], 'tropic'], paint: { 'line-color': '#333', 'line-width': 0.7, 'line-dasharray': [3, 3] } },
      { id: 'rivers', type: 'line', source: 'omt', 'source-layer': 'waterway', minzoom: 6, paint: { 'line-color': '#1c1c1c', 'line-width': 0.6 } },
      { id: 'states', type: 'line', source: 'omt', 'source-layer': 'boundary', minzoom: 4, filter: ['all', ['==', ['get', 'admin_level'], 4], ['==', ['get', 'maritime'], 0]], paint: { 'line-color': '#242424', 'line-width': 0.5, 'line-dasharray': [2, 2] } },
      { id: 'countries', type: 'line', source: 'omt', 'source-layer': 'boundary', filter: ['all', ['==', ['get', 'admin_level'], 2], ['==', ['get', 'maritime'], 0]], paint: { 'line-color': '#414141', 'line-width': ['interpolate', ['linear'], ['zoom'], 1, 0.4, 6, 0.9] } },
      { id: 'place-country', type: 'symbol', source: 'omt', 'source-layer': 'place', minzoom: 2.2, maxzoom: 7, filter: ['==', ['get', 'class'], 'country'], layout: { 'text-field': ['upcase', NAME], 'text-font': FONT, 'text-size': ['interpolate', ['linear'], ['zoom'], 2, 8.5, 6, 11.5], 'text-letter-spacing': 0.28, 'text-max-width': 8 }, paint: { 'text-color': '#888888', 'text-halo-color': '#030303', 'text-halo-width': 1 } },
      { id: 'place-town', type: 'symbol', source: 'omt', 'source-layer': 'place', minzoom: 6.5, filter: ['in', ['get', 'class'], ['literal', ['city', 'town']]], layout: { 'text-field': NAME, 'text-font': FONT, 'text-size': 10 }, paint: { 'text-color': '#888888', 'text-halo-color': '#030303', 'text-halo-width': 1 } },
      { id: 'arcs', type: 'line', source: 'arcs', layout: { 'line-cap': 'round' }, paint: { 'line-color': '#f9f9f9', 'line-opacity': 0.12, 'line-width': ['interpolate', ['linear'], ['get', 'n'], 1, 0.5, 8, 1.4] } },
      { id: 'arcs-hi', type: 'line', source: 'arcs', filter: NONE, layout: { 'line-cap': 'round' }, paint: { 'line-color': '#ffffff', 'line-opacity': 0.85, 'line-width': ['interpolate', ['linear'], ['get', 'n'], 1, 1.1, 8, 2.4] } },
      { id: 'roaster-pts', type: 'symbol', source: 'roasters', layout: { 'icon-image': 'eat-sq', 'icon-allow-overlap': true, 'icon-ignore-placement': true, 'icon-size': ['interpolate', ['linear'], ['zoom'], 1, 0.75, 6, 1] } },
      { id: 'roaster-hi', type: 'symbol', source: 'roasters', filter: NONE, layout: { 'icon-image': 'eat-sqf', 'icon-allow-overlap': true, 'icon-ignore-placement': true, 'icon-size': ['interpolate', ['linear'], ['zoom'], 1, 0.9, 6, 1.15] } },
      { id: 'p0', type: 'circle', source: 'producers', filter: ['==', ['get', 'n'], 0], paint: { 'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 1.4, 6, 2.6, 10, 4], 'circle-color': '#6a6a6a', 'circle-opacity': 0.8 } },
      { id: 'p-ring', type: 'circle', source: 'producers', filter: ['>', ['get', 'rc'], 1], paint: { 'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, ['+', 5, ['*', 0.8, ['min', ['get', 'rc'], 5]]], 8, ['+', 10, ['*', 1.2, ['min', ['get', 'rc'], 5]]]], 'circle-color': 'rgba(0,0,0,0)', 'circle-stroke-color': '#f9f9f9', 'circle-stroke-opacity': 0.4, 'circle-stroke-width': 0.8 } },
      { id: 'p', type: 'circle', source: 'producers', filter: ['>', ['get', 'n'], 0], paint: { 'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, ['+', 2, ['*', 0.14, ['min', ['get', 'n'], 20]]], 8, ['+', 4.5, ['*', 0.2, ['min', ['get', 'n'], 20]]]], 'circle-color': '#f9f9f9', 'circle-stroke-color': '#030303', 'circle-stroke-width': 1 } },
      { id: 'p-hi', type: 'circle', source: 'producers', filter: NONE, paint: { 'circle-radius': ['interpolate', ['linear'], ['zoom'], 1, 9, 8, 16], 'circle-color': 'rgba(249,249,249,0.08)', 'circle-stroke-color': '#ffffff', 'circle-stroke-width': 1.4 } },
      { id: 'roaster-label', type: 'symbol', source: 'roasters', minzoom: 3.6, layout: { 'text-field': ['upcase', ['get', 'r']], 'text-font': FONT, 'text-size': 10, 'text-letter-spacing': 0.2, 'text-offset': [0.9, 0], 'text-anchor': 'left' }, paint: { 'text-color': '#bdbdbd', 'text-halo-color': '#030303', 'text-halo-width': 1.4 } },
      { id: 'roaster-hi-label', type: 'symbol', source: 'roasters', filter: NONE, layout: { 'text-field': ['upcase', ['get', 'r']], 'text-font': FONT, 'text-size': 11, 'text-letter-spacing': 0.2, 'text-offset': [1, 0], 'text-anchor': 'left', 'text-allow-overlap': true }, paint: { 'text-color': '#ffffff', 'text-halo-color': '#030303', 'text-halo-width': 1.6 } },
      { id: 'p-label', type: 'symbol', source: 'producers', minzoom: 4.2, filter: ['>', ['get', 'n'], 0], layout: { 'text-field': ['get', 'name'], 'text-font': FONT, 'text-size': 10.5, 'text-offset': [1, 0], 'text-anchor': 'left', 'text-optional': true, 'symbol-sort-key': ['-', 0, ['get', 'rc']] }, paint: { 'text-color': '#d6d6d6', 'text-halo-color': '#030303', 'text-halo-width': 1.5 } },
      { id: 'p-hi-label', type: 'symbol', source: 'producers', filter: NONE, layout: { 'text-field': ['get', 'name'], 'text-font': FONT, 'text-size': 12, 'text-offset': [1.4, 0], 'text-anchor': 'left', 'text-allow-overlap': true }, paint: { 'text-color': '#ffffff', 'text-halo-color': '#030303', 'text-halo-width': 1.8 } },
    ],
  };
}
function initMap() {
  if (map || !globeAvailable) return;
  if (!window.maplibregl || !webglOk()) {
    globeAvailable = false;
    root.querySelector('[data-view="globe"]')?.setAttribute('disabled', '');
    toast(window.maplibregl ? 'The globe needs WebGL, which this browser has turned off. Showing the Web instead.' : 'The globe did not load. Showing the Web instead.');
    setView('web');
    return;
  }
  map = new maplibregl.Map({
    container: el.map, style: mapStyle(), center: [-32, 12], zoom: globeZoom(), minZoom: 0, maxZoom: 11,
    attributionControl: false, dragRotate: false, pitchWithRotate: false, touchPitch: false, renderWorldCopies: false,
  });
  map.touchZoomRotate.disableRotation();
  map.keyboard.disableRotation();
  configureGlobeDrag();
  map.addControl(new maplibregl.AttributionControl({ compact: true }), 'top-right');
  map.setPadding(mapPadding());
  map.on('styleimagemissing', e => {
    if (e.id === 'eat-sq') map.addImage('eat-sq', squareImage(false), { pixelRatio: 2 });
    if (e.id === 'eat-sqf') map.addImage('eat-sqf', squareImage(true), { pixelRatio: 2 });
  });
  map.on('load', () => {
    mapReady = true;
    if (!wide.matches) el.map.querySelector('.maplibregl-ctrl-attrib')?.classList.remove('maplibregl-compact-show');
    map.jumpTo({ zoom: globeZoom(), padding: mapPadding() });
    updateMapData();
    if (screen.t !== 'home') highlight(true);
    else if (F.country) { highlight(false); frameCountry(F.country); }
    else highlight(false);
  });
  map.on('click', e => {
    const p = e.point, box = [[p.x - 22, p.y - 22], [p.x + 22, p.y + 22]];
    const feats = map.queryRenderedFeatures(box, { layers: ['roaster-pts', 'p', 'p0'] });
    if (!feats.length) return;
    let best = null, bd = Infinity;
    for (const f of feats) {
      const s = map.project(f.geometry.coordinates);
      const d = Math.hypot(s.x - p.x, s.y - p.y) - (f.layer.id === 'roaster-pts' ? 5 : f.layer.id === 'p' ? 2 : 0);
      if (d < bd) { bd = d; best = f; }
    }
    if (best.layer.id === 'roaster-pts') go({ t: 'r', k: best.properties.r });
    else go({ t: 'p', k: best.properties.key });
  });
  map.on('mousemove', e => {
    if (!finePointer.matches) return;
    if (e.originalEvent.target.closest?.('.eat-pin')) { hideTip(); return; }
    const p = e.point, feats = map.queryRenderedFeatures([[p.x - 8, p.y - 8], [p.x + 8, p.y + 8]], { layers: ['roaster-pts', 'p', 'p0'] });
    if (map.dragPan.isActive()) { hideTip(); return; }
    map.getCanvas().style.cursor = feats.length ? 'pointer' : '';
    if (feats.length) showTip(feats[0].properties.name || feats[0].properties.r, e.originalEvent); else hideTip();
  });
  map.on('dragstart', () => {
    if (!wide.matches || !finePointer.matches) return;
    el.map.classList.add('is-dragging');
    map.getCanvas().style.cursor = 'grabbing';
    hideTip();
  });
  map.on('dragend', () => {
    el.map.classList.remove('is-dragging');
    map.getCanvas().style.cursor = '';
  });
  map.on('mouseout', hideTip);
  map.on('movestart', hideTip);
}
function configureGlobeDrag() {
  if (!map) return;
  // Native globe panning rotates longitude, including seamless antimeridian crossings.
  // Keep its hit-testing and click suppression; only tune the desktop release momentum.
  map.dragPan.enable(wide.matches && finePointer.matches && !reduced.matches
    ? { linearity: 0.35, maxSpeed: 1400, deceleration: 1400 }
    : undefined);
}
finePointer.addEventListener?.('change', configureGlobeDrag);
reduced.addEventListener?.('change', () => {
  if (reduced.matches) map?.stop();
  configureGlobeDrag();
});
function updateMapData() {
  if (!mapReady) return;
  map.getSource('producers').setData(producersGeo());
  map.getSource('arcs').setData(arcsGeo());
  map.getSource('roasters').setData(roastersGeo());
  highlight(false);
}
const camDuration = () => (reduced.matches ? 0 : 1400);
const cam = extra => ({ padding: mapPadding(), duration: camDuration(), easing: EASE, essential: true, ...extra });
function angular(a, b) {
  const p1 = a[1] * D2R, p2 = b[1] * D2R, dl = (b[0] - a[0]) * D2R;
  return Math.acos(clamp(Math.sin(p1) * Math.sin(p2) + Math.cos(p1) * Math.cos(p2) * Math.cos(dl), -1, 1)) / D2R;
}
function frame(points, maxZoom = 6) {
  if (!mapReady || !points.length) return;
  let x = 0, y = 0, z = 0;
  for (const [lng, lat] of points) { const a = lng * D2R, b = lat * D2R; x += Math.cos(b) * Math.cos(a); y += Math.cos(b) * Math.sin(a); z += Math.sin(b); }
  const center = [Math.atan2(y, x) / D2R, Math.atan2(z, Math.hypot(x, y)) / D2R];
  const spread = Math.max(0.6, ...points.map(p => angular(center, p)));
  const r = el.map.getBoundingClientRect(), pad = mapPadding();
  const half = Math.min(r.width - pad.left - pad.right, r.height - pad.top - pad.bottom) * 0.42;
  const zoom = clamp(Math.log2(half * 360 / (512 * spread)), globeZoom(), maxZoom);
  map.flyTo(cam({ center, zoom, padding: pad }));
}
function frameWorld() { if (mapReady) map.flyTo(cam({ center: [-32, 12], zoom: globeZoom() })); }
function recenterGlobe() { if (screen.t === 'p' || screen.t === 'r') highlight(true); else if (F.country) frameCountry(F.country); else frameWorld(); }
function frameCountry(c) { frame(VIS.producers.filter(p => p._mapped && p.country === c).map(p => p._pt), 6.5); }
function frameRoaster(r) {
  const ro = roasterOf(r);
  const pts = VIS.producers.filter(p => p._mapped && visibleLotsOf(p).some(l => l.roaster === r)).map(p => p._pt);
  if (Number.isFinite(ro.lng)) pts.push([ro.lng, ro.lat]);
  frame(pts, 5);
}
function highlight(camera) {
  if (view === 'web') webHighlight();
  if (!mapReady) return;
  const s = screen;
  const pk = s.t === 'p' ? s.k : null, rk = s.t === 'r' ? s.k : null;
  map.setFilter('p-hi', pk ? ['==', ['get', 'key'], pk] : NONE);
  map.setFilter('p-hi-label', pk ? ['==', ['get', 'key'], pk] : NONE);
  map.setFilter('arcs-hi', pk ? ['==', ['get', 'p'], pk] : rk ? ['==', ['get', 'r'], rk] : NONE);
  const rs = pk ? P.get(pk)._roasters : rk ? [rk] : [];
  map.setFilter('roaster-hi', rs.length ? ['in', ['get', 'r'], ['literal', rs]] : NONE);
  map.setFilter('roaster-hi-label', rs.length ? ['in', ['get', 'r'], ['literal', rs]] : NONE);
  map.setPaintProperty('arcs', 'line-opacity', pk || rk ? 0.05 : 0.12);
  placePin(pk ? P.get(pk) : null);
  if (!camera || view !== 'globe') return;
  if (pk) {
    const p = P.get(pk);
    if (p._mapped) map.flyTo(cam({ center: p._pt, zoom: Math.max(map.getZoom(), 4.4) }));
  } else if (rk) frameRoaster(rk);
}
// The selected producer's photo stands over its point, so the place and the people read together.
let pin = null;
function placePin(p) {
  pin?.remove();
  pin = null;
  const ph = photoOf(p);
  if (!ph || !p._mapped) return;
  const node = document.createElement('button');
  node.className = 'eat-pin';
  node.setAttribute('aria-label', `${p.name}: show the photo`);
  node.innerHTML = `<img class="${faceClass(ph).trim()}" src="${esc(sized(ph, 200))}" alt="">`;
  node.addEventListener('click', ev => {
    ev.stopPropagation();
    if (!wide.matches && snap === 'peek') setSnap('half');
    scrollBodyTo(el.body.querySelector('.eat-photo'));
  });
  pin = new maplibregl.Marker({ element: node, anchor: 'bottom', offset: [0, -12], opacityWhenCovered: '0' }).setLngLat(p._pt).addTo(map);
}
function showTip(text, ev) {
  if (!text || !finePointer.matches) return;
  const r = el.stage.getBoundingClientRect();
  el.tip.textContent = text;
  el.tip.hidden = false;
  el.tip.style.transform = `translate(${Math.round(ev.clientX - r.left + 14)}px,${Math.round(ev.clientY - r.top + 14)}px)`;
}
function hideTip() { el.tip.hidden = true; }

const mobileWeb = { roaster: '', page: 0, context: '' };
function renderMobileWeb() {
  if (!A || wide.matches || view !== 'web') return;
  const host = $('.eat-web-mobile');
  const roasters = ROASTERS.filter(r => VIS.lots.some(l => l.roaster === r && l.keys.some(k => VIS.pset.has(k))));
  if (!roasters.includes(mobileWeb.roaster)) mobileWeb.roaster = roasters.includes('DAK') ? 'DAK' : roasters[0] || '';
  const isProducer = screen.t === 'p';
  const producer = isProducer ? P.get(screen.k) : null;
  const roaster = screen.t === 'r' ? screen.k : mobileWeb.roaster;
  let items = isProducer ? visibleRoastersOf(producer).map(r => ({ name: r, t: 'r', key: r, sub: [roasterOf(r).city, roasterOf(r).country].filter(Boolean).join(', ') }))
    : VIS.producers.filter(p => visibleLotsOf(p).some(l => l.roaster === roaster)).sort((a, b) => b._roasters.length - a._roasters.length || byName(a.name, b.name)).map(p => ({ name: p.name, t: 'p', key: p.key, sub: p._roasters.length > 1 ? `Also listed by ${plural(p._roasters.length - 1, 'other roaster')}` : p.country || 'One roaster' }));
  const context = (isProducer ? 'p:' + screen.k : 'r:' + roaster) + '|' + items.map(x => x.key).join('|');
  if (context !== mobileWeb.context) { mobileWeb.context = context; mobileWeb.page = 0; }
  const available = el.stage.clientHeight - Math.min(visibleH || snaps.peek, snaps.half);
  const pageSize = clamp(Math.floor((available - (screen.t === 'home' ? 230 : 166)) / 78), 1, 5);
  const pages = Math.max(1, Math.ceil(items.length / pageSize));
  mobileWeb.page = clamp(mobileWeb.page, 0, pages - 1);
  const first = mobileWeb.page * pageSize;
  const page = items.slice(first, first + pageSize);
  const name = isProducer ? producer.name : roaster;
  host.innerHTML = `<div class="eat-network-head"><label class="eat-sr" for="eat-network-roaster">Explore a roaster's connections</label><select id="eat-network-roaster" class="eat-network-select">${isProducer ? '<option value="" selected disabled>Explore another roaster…</option>' : ''}${[...new Set([...roasters, ...(!isProducer && roaster ? [roaster] : [])])].map(r => `<option value="${esc(r)}"${!isProducer && r === roaster ? ' selected' : ''}>${esc(r)}</option>`).join('')}</select><p>${isProducer ? 'Roasters listing this producer' : 'Choose a producer to trace its connections'}</p></div>
    ${items.length ? `<div class="eat-network-content"><button class="eat-network-source" data-go-${isProducer ? 'p' : 'r'}="${esc(isProducer ? producer.key : roaster)}"><i class="${isProducer ? 'eat-k-dot' : 'eat-sq'}" aria-hidden="true"></i><span>${esc(name)}</span><small>View profile</small></button><div class="eat-network-list">${page.map(x => `<button class="eat-network-item" data-go-${x.t}="${esc(x.key)}"><span>${esc(x.name)}</span><small>${esc(x.sub)}</small></button>`).join('')}</div></div>` : '<p class="eat-network-empty">No connections match these filters. Try clearing a filter.</p>'}
    <div class="eat-network-pager"><button class="eat-icon-btn" data-web-page="-1" aria-label="Previous connections" ${mobileWeb.page === 0 ? 'disabled' : ''}>${ICON.back}</button><span role="status">${items.length ? `${first + 1}–${Math.min(first + pageSize, items.length)} of ${items.length} ${isProducer ? 'roasters' : 'producers'}` : 'No connections'}</span><button class="eat-icon-btn" data-web-page="1" aria-label="Next connections" ${mobileWeb.page === pages - 1 ? 'disabled' : ''}>${ICON.chev}</button></div>`;
  const select = host.querySelector('select');
  select.disabled = !roasters.length;
  select.addEventListener('change', () => {
    mobileWeb.roaster = select.value; mobileWeb.page = 0;
    if (screen.t !== 'home') go({ t: 'r', k: select.value });
    else renderMobileWeb();
    $('.eat-network-select').focus({preventScroll:true});
  });
}

/* ---------- web: roasters on a ring, shared producers placed between them ---------- */
const SVGNS = 'http://www.w3.org/2000/svg';
const web = { L: null, k: 1, tx: 0, ty: 0, w: 0, h: 0, nodes: null, labelBoxes: [], anim: 0 };
const measureCtx = document.createElement('canvas').getContext('2d');
const textW = (s, font) => { measureCtx.font = font; return measureCtx.measureText(s).width; };
const R_FONT = '400 15px "Cormorant Garamond", Georgia, serif', P_FONT = '500 10.5px Montserrat, Arial, sans-serif';
function splitName(name) {
  if (name.length <= 10 || !name.includes(' ')) return [name];
  const mid = name.length / 2;
  let best = -1;
  for (let i = 0; i < name.length; i++) if (name[i] === ' ' && (best < 0 || Math.abs(i - mid) < Math.abs(best - mid))) best = i;
  return [name.slice(0, best), name.slice(best + 1)];
}
function webModel() {
  const per = new Map();
  for (const l of VIS.lots) for (const k of l.keys) {
    if (!VIS.pset.has(k)) continue;
    if (!per.has(k)) per.set(k, new Map());
    const m = per.get(k);
    m.set(l.roaster, (m.get(l.roaster) || 0) + 1);
  }
  const rset = new Set();
  for (const m of per.values()) for (const r of m.keys()) rset.add(r);
  const pair = (a, b) => (a < b ? a + '|' + b : b + '|' + a);
  const W = new Map();
  for (const m of per.values()) if (m.size > 1) { const rs = [...m.keys()]; for (let i = 0; i < rs.length; i++) for (let j = i + 1; j < rs.length; j++) W.set(pair(rs[i], rs[j]), (W.get(pair(rs[i], rs[j])) || 0) + 1); }
  return { per, roasters: ringOrder([...rset].sort(byName), W, pair) };
}
// Seat roasters that share producers next to each other, so shared producers sit near the rim, not in a knot.
function ringOrder(rs, W, pair) {
  const n = rs.length;
  if (n < 4) return rs;
  const w = (a, b) => W.get(pair(a, b)) || 0;
  const cost = o => { let c = 0; for (let i = 0; i < n; i++) for (let j = i + 1; j < n; j++) { const d = Math.min(j - i, n - j + i); c += w(o[i], o[j]) * d * d; } return c; };
  let best = rs.slice(), bc = cost(best);
  for (let pass = 0, better = true; better && pass < 30; pass++) {
    better = false;
    for (let i = 0; i < n; i++) for (let j = i + 1; j < n; j++) {
      const o = best.slice(); [o[i], o[j]] = [o[j], o[i]];
      const c = cost(o);
      if (c < bc - 1e-9) { best = o; bc = c; better = true; }
    }
  }
  return best;
}
function webLayout(model) {
  const r = el.stage.getBoundingClientRect();
  const w = r.width, h = r.height;
  web.w = w; web.h = h;
  const top = wide.matches ? 132 : 122, bottom = (wide.matches ? 0 : snaps.peek) + 40;
  const labels = model.roasters.map(name => { const lines = splitName(name); return { lines, width: Math.max(...lines.map(s => textW(s, R_FONT))) + 22 }; });
  const labelW = Math.max(40, ...labels.map(l => l.width));
  const ry = Math.max(90, (h - top - bottom) / 2 - 16);
  const rx = Math.max(88, Math.min(w / 2 - labelW - 10, ry * 1.08));
  const cx = w / 2, cy = top + (h - top - bottom) / 2;
  // Equal spacing along the ellipse, starting at the top.
  const N = 720, samples = [];
  let len = 0, prev = null;
  for (let i = 0; i <= N; i++) {
    const t = -Math.PI / 2 + (i / N) * Math.PI * 2, pt = [cx + rx * Math.cos(t), cy + ry * Math.sin(t)];
    if (prev) len += Math.hypot(pt[0] - prev[0], pt[1] - prev[1]);
    samples.push({ pt, len }); prev = pt;
  }
  const n = model.roasters.length, anchors = new Map();
  let j = 0;
  model.roasters.forEach((name, i) => {
    const target = (len * i) / Math.max(1, n);
    while (j < samples.length - 1 && samples[j].len < target) j++;
    const [x, y] = samples[j].pt;
    anchors.set(name, { name, x, y, lines: labels[i].lines, count: 0 });
  });
  const shared = [], fans = new Map();
  for (const [k, m] of model.per) {
    const tot = [...m.values()].reduce((a, b) => a + b, 0);
    for (const rname of m.keys()) anchors.get(rname).count++;
    if (m.size > 1) {
      let x = 0, y = 0, s = 0;
      for (const [rname, c] of m) { const a = anchors.get(rname); x += a.x * c; y += a.y * c; s += c; }
      x = cx + (x / s - cx) * 0.64; y = cy + (y / s - cy) * 0.64;
      shared.push({ k, m, tot, tx: x, ty: y, x: x + hash(k) * 6, y: y + hash(k + '#') * 6, r: 3 + Math.min(tot, 12) * 0.3, kind: 'shared', photo: photoOf(P.get(k)) });
    } else {
      const rname = m.keys().next().value;
      if (!fans.has(rname)) fans.set(rname, []);
      fans.get(rname).push({ k, m, tot, kind: 'solo', rname, photo: photoOf(P.get(k)) });
    }
  }
  // Space shared producers to fill the ring: spacing grows with the room available per node.
  const ex = rx * 0.82, ey = ry * 0.86;
  const spacing = clamp(Math.sqrt((Math.PI * ex * ey) / Math.max(1, shared.length)) * 0.55, 8, 30);
  for (let it = 0; it < 220; it++) {
    for (let a = 0; a < shared.length; a++) for (let b = a + 1; b < shared.length; b++) {
      const p = shared[a], q = shared[b];
      let dx = q.x - p.x, dy = q.y - p.y, d = Math.hypot(dx, dy);
      const min = p.r + q.r + spacing;
      if (d >= min) continue;
      if (d < 0.01) { dx = hash(p.k + q.k); dy = hash(q.k + p.k); d = Math.hypot(dx, dy) || 1; }
      const push = (min - d) / 2, ux = dx / d, uy = dy / d;
      p.x -= ux * push; p.y -= uy * push; q.x += ux * push; q.y += uy * push;
    }
    for (const p of shared) {
      p.x += (p.tx - p.x) * 0.02; p.y += (p.ty - p.y) * 0.02;
      const e = ((p.x - cx) / ex) ** 2 + ((p.y - cy) / ey) ** 2;
      if (e > 1) { const s = 1 / Math.sqrt(e); p.x = cx + (p.x - cx) * s; p.y = cy + (p.y - cy) * s; }
    }
  }
  const solo = [];
  for (const [rname, list] of fans) {
    const a = anchors.get(rname), inward = Math.atan2(cy - a.y, cx - a.x);
    list.sort((p, q) => q.tot - p.tot || byName(p.k, q.k));
    list.forEach((s, i) => {
      const d = 13 + 5.2 * Math.sqrt(i + 0.5), ang = inward + (((i * 0.6180339887) % 1) * 2 - 1) * 1.2;
      s.x = a.x + Math.cos(ang) * d; s.y = a.y + Math.sin(ang) * d; s.r = 1.6 + Math.min(s.tot, 6) * 0.18;
      solo.push(s);
    });
  }
  return { cx, cy, rx, ry, anchors, shared, solo };
}
function webBuild() {
  if (!A) return;
  if (!wide.matches) { renderMobileWeb(); return; }
  const svg = el.web;
  const model = webModel();
  if (!model.roasters.length) {
    svg.innerHTML = '';
    web.L = null;
    el.caption.dataset.empty = '1';
    toastOnce('Nothing to draw for these filters.');
    return;
  }
  delete el.caption.dataset.empty;
  const L = webLayout(model);
  web.L = L;
  const edges = [], parts = ['<g class="eat-w-edges">'];
  for (const p of L.shared) for (const [rname, n] of p.m) {
    edges.push({ p, a: L.anchors.get(rname), n });
    parts.push(`<path class="eat-w-edge" data-p="${esc(p.k)}" data-r="${esc(rname)}" stroke-width="${(0.6 + Math.min(n, 6) * 0.25).toFixed(2)}"/>`);
  }
  parts.push('</g><g class="eat-w-fans">');
  for (const s of L.solo) parts.push(`<circle class="eat-w-solo" data-p="${esc(s.k)}" data-r="${esc(s.rname)}"/>`);
  parts.push('</g><g class="eat-w-shared">');
  for (const p of L.shared) parts.push(`<circle class="eat-w-node" data-p="${esc(p.k)}"/>`);
  parts.push('</g><g class="eat-w-photos">');
  const withPhoto = [...L.shared, ...L.solo].filter(d => d.photo);
  for (const d of withPhoto) parts.push(`<g class="eat-w-ph" data-p="${esc(d.k)}" display="none"><image href="${esc(sized(d.photo, 120))}" preserveAspectRatio="xMidYMid slice"/><rect class="eat-w-ph-frame"/></g>`);
  parts.push('</g><g class="eat-w-roasters">');
  for (const a of L.anchors.values()) parts.push(`<rect class="eat-w-roaster" data-r="${esc(a.name)}" width="10" height="10"/>`);
  parts.push('</g><g class="eat-w-labels">');
  for (const a of L.anchors.values()) parts.push(`<text class="eat-w-rlabel" data-r="${esc(a.name)}">${a.lines.map((s, i) => `<tspan x="0" dy="${i ? '1.05em' : '0'}">${esc(s)}</tspan>`).join('')}</text>`);
  for (const p of [...L.shared, ...L.solo]) parts.push(`<text class="eat-w-plabel" data-p="${esc(p.k)}" display="none"></text>`);
  parts.push('</g>');
  svg.setAttribute('viewBox', `0 0 ${web.w} ${web.h}`);
  svg.innerHTML = parts.join('');
  const pick = sel => [...svg.querySelectorAll(sel)];
  web.nodes = {
    edges: pick('.eat-w-edge').map((node, i) => ({ node, ...edges[i] })),
    solo: pick('.eat-w-solo').map((node, i) => ({ node, d: L.solo[i] })),
    shared: pick('.eat-w-node').map((node, i) => ({ node, d: L.shared[i] })),
    roasters: pick('.eat-w-roaster').map((node, i) => ({ node, d: [...L.anchors.values()][i] })),
    rlabels: pick('.eat-w-rlabel').map((node, i) => ({ node, d: [...L.anchors.values()][i] })),
    plabels: new Map(pick('.eat-w-plabel').map(node => [node.dataset.p, node])),
    photos: pick('.eat-w-ph').map((node, i) => ({ node, img: node.firstElementChild, frame: node.lastElementChild, d: withPhoto[i] })),
  };
  webClamp();
  webPaint();
  webHighlight();
}
function toastOnce(text) { if (toastOnce.last !== text) { toastOnce.last = text; toast(text); setTimeout(() => (toastOnce.last = ''), 3000); } }
const WX = x => x * web.k + web.tx, WY = y => y * web.k + web.ty;
// Photos appear as you zoom in, and always on the selected producer.
function tileOf(d) {
  if (!d.photo) return 0;
  if (screen.t === 'p' && screen.k === d.k) return 48;
  return web.k >= 1.6 ? clamp(13 * (1 + (web.k - 1) * 0.35), 18, 40) : 0;
}
const radiusOf = d => tileOf(d) / 2 || d.r * (1 + (web.k - 1) * 0.35);
function webPaint() {
  const L = web.L, N = web.nodes;
  if (!L || !N) return;
  const grow = 1 + (web.k - 1) * 0.35;
  for (const e of N.edges) {
    const x1 = e.p.x, y1 = e.p.y, x2 = e.a.x, y2 = e.a.y;
    const mx = (x1 + x2) / 2, my = (y1 + y2) / 2, qx = mx + (L.cx - mx) * 0.16, qy = my + (L.cy - my) * 0.16;
    e.node.setAttribute('d', `M${WX(x1).toFixed(1)},${WY(y1).toFixed(1)}Q${WX(qx).toFixed(1)},${WY(qy).toFixed(1)} ${WX(x2).toFixed(1)},${WY(y2).toFixed(1)}`);
  }
  for (const { node, d } of N.solo) { node.setAttribute('cx', WX(d.x).toFixed(1)); node.setAttribute('cy', WY(d.y).toFixed(1)); node.setAttribute('r', (d.r * grow).toFixed(2)); }
  for (const { node, d } of N.shared) { node.setAttribute('cx', WX(d.x).toFixed(1)); node.setAttribute('cy', WY(d.y).toFixed(1)); node.setAttribute('r', (d.r * grow).toFixed(2)); }
  for (const { node, d } of N.roasters) { node.setAttribute('x', (WX(d.x) - 5).toFixed(1)); node.setAttribute('y', (WY(d.y) - 5).toFixed(1)); }
  for (const { node, d } of N.rlabels) {
    const dx = d.x - L.cx, dy = d.y - L.cy, len = Math.hypot(dx, dy) || 1, ux = dx / len, uy = dy / len;
    const lines = d.lines.length, x = WX(d.x), y = WY(d.y);
    let anchor = 'middle', lx = x, ly;
    if (Math.abs(ux) > 0.32) { anchor = ux > 0 ? 'start' : 'end'; lx = x + (ux > 0 ? 12 : -12); ly = y - (lines - 1) * 8 + 5; }
    else ly = uy < 0 ? y - 12 - (lines - 1) * 16 : y + 22;
    node.setAttribute('text-anchor', anchor);
    node.setAttribute('transform', `translate(${lx.toFixed(1)},${ly.toFixed(1)})`);
  }
  for (const t of N.photos) {
    const size = tileOf(t.d);
    if (!size) { t.node.setAttribute('display', 'none'); continue; }
    const x = (WX(t.d.x) - size / 2).toFixed(1), y = (WY(t.d.y) - size / 2).toFixed(1);
    for (const n of [t.img, t.frame]) { n.setAttribute('x', x); n.setAttribute('y', y); n.setAttribute('width', size.toFixed(1)); n.setAttribute('height', size.toFixed(1)); }
    t.node.setAttribute('display', 'inline');
  }
  for (const [k, node] of N.plabels) if (node.getAttribute('display') !== 'none') placeLabel(k, node);
}
function placeLabel(k, node) {
  const d = webNode(k);
  if (!d || !node._side) return;
  const x = WX(d.x), y = WY(d.y), r = radiusOf(d);
  node.setAttribute('text-anchor', node._side > 0 ? 'start' : 'end');
  node.setAttribute('x', (x + node._side * (r + 5)).toFixed(1));
  node.setAttribute('y', (y + 3.5).toFixed(1));
}
function webNode(k) { return web.L && (web.L.shared.find(p => p.k === k) || web.L.solo.find(p => p.k === k)); }
// Name as many producers as fit without collisions; zooming in makes room for more.
function webLabels() {
  const L = web.L, N = web.nodes;
  if (!L || !N) return;
  const boxes = [], overlaps = b => boxes.some(o => b.x < o.x + o.w && b.x + b.w > o.x && b.y < o.y + o.h && b.y + b.h > o.y);
  for (const { node } of N.rlabels) { try { const bb = node.getBBox(), m = node.transform.baseVal.consolidate()?.matrix; if (m) boxes.push({ x: bb.x + m.e - 3, y: bb.y + m.f - 2, w: bb.width + 6, h: bb.height + 4 }); } catch { /* not rendered */ } }
  for (const { d } of N.roasters) boxes.push({ x: WX(d.x) - 8, y: WY(d.y) - 8, w: 16, h: 16 });
  for (const { d } of N.photos) { const size = tileOf(d); if (size) boxes.push({ x: WX(d.x) - size / 2, y: WY(d.y) - size / 2, w: size, h: size }); }
  const sel = selectionSets();
  const cands = [...L.shared, ...(web.k >= 2 ? L.solo : [])].map(d => ({
    d, pri: (sel.p.has(d.k) ? 1000 : 0) + (sel.lit.has(d.k) ? 500 : 0) + (d.kind === 'shared' ? 100 + d.m.size * 10 : 0) + d.tot,
  })).sort((a, b) => b.pri - a.pri);
  const limit = web.k < 1.25 ? (wide.matches ? 40 : 16) : web.k < 2 ? 60 : 400;
  const maxChars = web.k < 1.6 ? 22 : 40;
  const vw = web.w, vh = web.h - (wide.matches ? 0 : visibleH);
  let shown = 0;
  web.labelBoxes = [];
  for (const [, node] of N.plabels) node.setAttribute('display', 'none');
  for (const { d, pri } of cands) {
    if (shown >= limit && pri < 500) continue;
    const node = N.plabels.get(d.k);
    const name = P.get(d.k)?.name || '';
    const text = name.length > maxChars ? name.slice(0, maxChars - 1).trimEnd() + '…' : name;
    const tw = textW(text, P_FONT), x = WX(d.x), y = WY(d.y), r = radiusOf(d);
    if (x < -20 || x > vw + 20 || y < 104 || y > vh) continue;
    const sides = x < L.cx * web.k + web.tx ? [1, -1] : [-1, 1];
    let placed = false;
    for (const side of sides) {
      const bx = side > 0 ? x + r + 4 : x - r - 4 - tw;
      const b = { x: bx - 2, y: y - 8, w: tw + 4, h: 14 };
      if (b.x < 2 || b.x + b.w > vw - 2) continue;
      if (overlaps(b) && pri < 1000) continue;
      boxes.push(b); web.labelBoxes.push({ ...b, k: d.k });
      node.textContent = text; node._side = side; node.setAttribute('display', 'inline');
      placeLabel(d.k, node);
      placed = true; shown++;
      break;
    }
    if (!placed && pri >= 1000) { node.textContent = text; node._side = 1; node.setAttribute('display', 'inline'); placeLabel(d.k, node); }
  }
}
function selectionSets() {
  const p = new Set(), lit = new Set(), r = new Set(), mid = new Set();
  if (!web.L) return { p, lit, r, mid };
  if (screen.t === 'p') {
    p.add(screen.k);
    const m = web.L.shared.find(x => x.k === screen.k)?.m || web.L.solo.find(x => x.k === screen.k)?.m;
    if (m) for (const rn of m.keys()) r.add(rn);
  } else if (screen.t === 'r') {
    r.add(screen.k);
    for (const x of web.L.shared) if (x.m.has(screen.k)) { lit.add(x.k); for (const rn of x.m.keys()) if (rn !== screen.k) mid.add(rn); }
    for (const x of web.L.solo) if (x.rname === screen.k) lit.add(x.k);
  }
  return { p, lit, r, mid };
}
function webHighlight() {
  renderMobileWeb();
  const N = web.nodes;
  if (!N || view !== 'web') return;
  const s = selectionSets(), on = s.p.size > 0 || s.r.size > 0;
  el.web.classList.toggle('has-sel', on);
  const mark = (node, cls) => { node.classList.toggle('on', cls === 'on'); node.classList.toggle('mid', cls === 'mid'); };
  for (const e of N.edges) {
    const pk = e.p.k, rn = e.a.name;
    mark(e.node, s.p.has(pk) || (s.r.has(rn) && s.lit.has(pk)) ? 'on' : s.lit.has(pk) && s.mid.has(rn) ? 'mid' : '');
  }
  for (const { node, d } of [...N.shared, ...N.solo]) mark(node, s.p.has(d.k) || s.lit.has(d.k) ? 'on' : '');
  for (const [k, node] of N.plabels) mark(node, s.p.has(k) || s.lit.has(k) ? 'on' : '');
  for (const { node, d } of [...N.roasters, ...N.rlabels]) mark(node, s.r.has(d.name) ? 'on' : s.mid.has(d.name) ? 'mid' : '');
  for (const { node, d } of N.photos) mark(node, s.p.has(d.k) || s.lit.has(d.k) ? 'on' : '');
  webPaint();
  webLabels();
}
function webClamp() {
  const slack = wide.matches ? 0 : Math.max(0, snaps.half - snaps.peek);
  web.k = clamp(web.k, 1, 7);
  web.tx = clamp(web.tx, web.w - web.w * web.k, 0);
  web.ty = clamp(web.ty, web.h - web.h * web.k - slack, 0);
}
function webAnimate(k, tx, ty) {
  cancelAnimationFrame(web.anim);
  const k0 = web.k, x0 = web.tx, y0 = web.ty, t0 = performance.now(), dur = reduced.matches ? 0 : 380;
  const step = now => {
    const f = dur ? Math.min(1, (now - t0) / dur) : 1, e = EASE(f);
    web.k = k0 + (k - k0) * e; web.tx = x0 + (tx - x0) * e; web.ty = y0 + (ty - y0) * e;
    webClamp(); webPaint();
    if (f < 1) web.anim = requestAnimationFrame(step); else webLabels();
  };
  web.anim = requestAnimationFrame(step);
}
function webZoomAt(k, x, y) {
  const nk = clamp(k, 1, 7), f = nk / web.k;
  return [nk, x - (x - web.tx) * f, y - (y - web.ty) * f];
}
function webReset() { webAnimate(1, 0, 0); }
function webHit(x, y) {
  const L = web.L;
  if (!L) return null;
  for (const a of L.anchors.values()) if (Math.abs(WX(a.x) - x) <= 8 && Math.abs(WY(a.y) - y) <= 8) return { t: 'r', k: a.name };
  for (const b of web.labelBoxes) if (x >= b.x && x <= b.x + b.w && y >= b.y - 4 && y <= b.y + b.h + 4) return { t: 'p', k: b.k };
  for (const { node, d } of web.nodes.rlabels) {
    try { const bb = node.getBBox(), m = node.transform.baseVal.consolidate()?.matrix; if (m && x >= bb.x + m.e - 6 && x <= bb.x + m.e + bb.width + 6 && y >= bb.y + m.f - 6 && y <= bb.y + m.f + bb.height + 6) return { t: 'r', k: d.name }; } catch { /* hidden */ }
  }
  let best = null, bd = 24;
  for (const a of L.anchors.values()) { const d = Math.hypot(WX(a.x) - x, WY(a.y) - y) - 6; if (d < bd) { bd = d; best = { t: 'r', k: a.name }; } }
  for (const p of L.shared) { const d = Math.hypot(WX(p.x) - x, WY(p.y) - y) - radiusOf(p); if (d < bd) { bd = d; best = { t: 'p', k: p.k }; } }
  for (const s of L.solo) { if (web.k < 1.8 && !tileOf(s)) continue; const d = Math.hypot(WX(s.x) - x, WY(s.y) - y) - Math.max(2, tileOf(s) / 2); if (d < bd) { bd = d; best = { t: 'p', k: s.k }; } }
  // Zoomed out, a tap on a roaster's fan of single-roaster producers means the roaster.
  if (web.k < 1.8 && !best) { for (const a of L.anchors.values()) if (Math.hypot(WX(a.x) - x, WY(a.y) - y) < 52 * web.k) { best = { t: 'r', k: a.name }; break; } }
  return best;
}
// Gestures: tap selects, drag pans, pinch or wheel zooms, double tap zooms in.
const pointers = new Map();
let gesture = null, lastTap = { t: 0, x: 0, y: 0 };
const local2 = e => { const r = el.web.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
el.web.addEventListener('pointerdown', e => {
  if (e.pointerType === 'mouse' && e.button !== 0) return;
  try { el.web.setPointerCapture(e.pointerId); } catch { /* ignore */ }
  pointers.set(e.pointerId, local2(e));
  cancelAnimationFrame(web.anim);
  hideTip();
  if (pointers.size === 1) { const p = local2(e); gesture = { type: 'pan', x0: p.x, y0: p.y, tx0: web.tx, ty0: web.ty, t0: e.timeStamp, moved: false }; }
  else if (pointers.size === 2) {
    const [a, b] = [...pointers.values()];
    gesture = { type: 'pinch', d0: Math.hypot(a.x - b.x, a.y - b.y) || 1, k0: web.k, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2, tx0: web.tx, ty0: web.ty };
  }
});
el.web.addEventListener('pointermove', e => {
  if (!pointers.has(e.pointerId)) {
    if (finePointer.matches && !gesture) { const p = local2(e), h = webHit(p.x, p.y); el.web.style.cursor = h ? 'pointer' : web.k > 1 ? 'grab' : ''; if (h) showTip(h.t === 'p' ? P.get(h.k)?.name : h.k, e); else hideTip(); }
    return;
  }
  pointers.set(e.pointerId, local2(e));
  if (!gesture) return;
  if (gesture.type === 'pan') {
    const p = local2(e), dx = p.x - gesture.x0, dy = p.y - gesture.y0;
    if (!gesture.moved && Math.hypot(dx, dy) < 7) return;
    gesture.moved = true;
    web.tx = gesture.tx0 + dx; web.ty = gesture.ty0 + dy;
  } else if (pointers.size >= 2) {
    const [a, b] = [...pointers.values()];
    const k = clamp(gesture.k0 * (Math.hypot(a.x - b.x, a.y - b.y) / gesture.d0), 1, 7);
    const mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    web.tx = mx - (gesture.mx - gesture.tx0) * (k / gesture.k0);
    web.ty = my - (gesture.my - gesture.ty0) * (k / gesture.k0);
    web.k = k;
  }
  webClamp();
  cancelAnimationFrame(web.anim);
  web.anim = requestAnimationFrame(webPaint);
});
function endPointer(e) {
  if (!pointers.has(e.pointerId)) return;
  const p = local2(e);
  pointers.delete(e.pointerId);
  if (!gesture) return;
  if (gesture.type === 'pan' && !gesture.moved && e.type === 'pointerup' && e.timeStamp - gesture.t0 < 500) {
    const dbl = e.timeStamp - lastTap.t < 320 && Math.hypot(p.x - lastTap.x, p.y - lastTap.y) < 30;
    lastTap = { t: dbl ? 0 : e.timeStamp, x: p.x, y: p.y };
    if (dbl) { const [k, tx, ty] = webZoomAt(web.k < 6 ? web.k * 2 : 1, p.x, p.y); webAnimate(k, tx, ty); }
    else { const h = webHit(p.x, p.y); if (h) go(h); }
  }
  if (pointers.size === 1 && gesture.type === 'pinch') {
    const [q] = [...pointers.values()];
    gesture = { type: 'pan', x0: q.x, y0: q.y, tx0: web.tx, ty0: web.ty, t0: e.timeStamp, moved: true };
    return;
  }
  if (!pointers.size) { gesture = null; webLabels(); }
}
el.web.addEventListener('pointerup', endPointer);
el.web.addEventListener('pointercancel', endPointer);
el.web.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') hideTip(); });
el.web.addEventListener('wheel', e => {
  e.preventDefault();
  const p = local2(e), [k, tx, ty] = webZoomAt(web.k * Math.exp(-e.deltaY * 0.0022), p.x, p.y);
  web.k = k; web.tx = tx; web.ty = ty;
  webClamp(); webPaint();
  clearTimeout(web.wheelT); web.wheelT = setTimeout(webLabels, 140);
}, { passive: false });

/* ---------- layout changes ---------- */
let resizeT = 0;
function onResize() {
  configureGlobeDrag();
  placeUnderHeader();
  measureSheet();
  if (wide.matches) { root.style.setProperty('--eat-hidden', '0px'); delete root.dataset.snap; el.stage.inert = !el.picker.hidden; }
  else setSnap(snap, { mapEase: false });
  if (map) { map.resize(); if (mapReady && screen.t === 'home' && !F.country) map.jumpTo({ zoom: Math.max(map.getZoom(), globeZoom()), padding: mapPadding() }); }
  if (view === 'web') { const k = web.k, tx = web.tx, ty = web.ty; webBuild(); web.k = k; web.tx = tx; web.ty = ty; webClamp(); webPaint(); webLabels(); }
}
addEventListener('resize', () => { clearTimeout(resizeT); resizeT = setTimeout(onResize, 120); });
wide.addEventListener?.('change', onResize);
window.visualViewport?.addEventListener('resize', () => { clearTimeout(resizeT); resizeT = setTimeout(onResize, 80); });

/* ---------- start ---------- */
function start(data) {
  prepare(data);
  computeVisible();
  renderChips();
  const target = readHash();
  view = new URLSearchParams(location.hash.slice(1)).get('v') === 'web' ? 'web' : 'globe';
  const st = history.state;
  if (st && st.eat != null) {
    // A reload, or a return the page cache did not keep: this page's entries are still in history.
    depth = st.eat;
    if (st.picker != null) { ignorePop++; history.back(); }
    screen = target;
    renderScreen();
    setSnap(target.t === 'home' ? 'peek' : 'half', { mapEase: false });
    setView(view);
    highlight(true);
  } else {
    depth = 0;
    history.replaceState({ eat: 0 }, '', hashFor({ t: 'home' }));
    screen = { t: 'home' };
    renderScreen();
    setSnap('peek', { mapEase: false });
    setView(view);
    if (target.t !== 'home') go(target);
  }
  root.classList.add('is-ready');
  if (document.fonts?.ready) document.fonts.ready.then(() => { measureSheet(); setSnap(snap, { mapEase: false }); if (view === 'web') webBuild(); });
}
function fail() {
  el.body.innerHTML = '<div class="eat-empty"><p>The atlas could not load. Check your connection and reload the page.</p></div>';
  root.classList.add('is-ready');
}
const src = root.dataset.src;
fetch(src, { credentials: 'same-origin' })
  .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
  .then(t => JSON.parse(t.trim().replace(/^window\.ATLAS\s*=\s*/, '').replace(/;\s*$/, '')))
  .then(start)
  .catch(fail);
})();
